/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
};

export type Address = {
  __typename?: 'Address';
  addressId: Scalars['ID'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  /** The id from the platform for the building profile seed data */
  buildingProfile?: Maybe<BuildingProfile>;
  city: Scalars['String'];
  county: Scalars['String'];
  createdAt: Scalars['Date'];
  customers?: Maybe<Array<Customer>>;
  displayName: Scalars['String'];
  hubspotAddressId?: Maybe<Scalars['ID']>;
  isTest: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  locationDetails?: Maybe<AddressLocationDetails>;
  longitude?: Maybe<Scalars['Float']>;
  /** Id only field, this will have the same id as the buildingProfile */
  platformBuildingProfileId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
  updatedAt: Scalars['Date'];
  visits?: Maybe<Array<Visit>>;
};

export type AddressFilter = {
  addressId?: InputMaybe<Array<Scalars['ID']>>;
  isTest?: InputMaybe<Scalars['Boolean']>;
};

export type AddressInput = {
  addressId?: InputMaybe<Scalars['ID']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  hubspotAddressId?: InputMaybe<Scalars['ID']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  platformBuildingProfileId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type AddressLocationDetails = {
  __typename?: 'AddressLocationDetails';
  currentSalesTerritoryContainsLocation: Scalars['Boolean'];
};

export type AnnualResult = {
  __typename?: 'AnnualResult';
  endUseCoalClothesDryer?: Maybe<HeatUnit>;
  endUseCoalFireplace?: Maybe<HeatUnit>;
  endUseCoalGenerator?: Maybe<HeatUnit>;
  endUseCoalGrill?: Maybe<HeatUnit>;
  endUseCoalHeating?: Maybe<HeatUnit>;
  endUseCoalHotWater?: Maybe<HeatUnit>;
  endUseCoalLighting?: Maybe<HeatUnit>;
  endUseCoalMechVentPreheating?: Maybe<HeatUnit>;
  endUseCoalRangeOven?: Maybe<HeatUnit>;
  endUseElectricityCeilingFan?: Maybe<HeatUnit>;
  endUseElectricityClothesDryer?: Maybe<HeatUnit>;
  endUseElectricityClothesWasher?: Maybe<HeatUnit>;
  endUseElectricityCooling?: Maybe<HeatUnit>;
  endUseElectricityCoolingFansPumps?: Maybe<HeatUnit>;
  endUseElectricityDehumidifier?: Maybe<HeatUnit>;
  endUseElectricityDishwasher?: Maybe<HeatUnit>;
  endUseElectricityElectricVehicleCharging?: Maybe<HeatUnit>;
  endUseElectricityFreezer?: Maybe<HeatUnit>;
  endUseElectricityGenerator?: Maybe<HeatUnit>;
  endUseElectricityHeating?: Maybe<HeatUnit>;
  endUseElectricityHeatingFansPumps?: Maybe<HeatUnit>;
  endUseElectricityHotTubHeater?: Maybe<HeatUnit>;
  endUseElectricityHotTubPump?: Maybe<HeatUnit>;
  endUseElectricityHotWater?: Maybe<HeatUnit>;
  endUseElectricityHotWaterRecircPump?: Maybe<HeatUnit>;
  endUseElectricityHotWaterSolarThermalPump?: Maybe<HeatUnit>;
  endUseElectricityLightingExterior?: Maybe<HeatUnit>;
  endUseElectricityLightingGarage?: Maybe<HeatUnit>;
  endUseElectricityLightingInterior?: Maybe<HeatUnit>;
  endUseElectricityMechVent?: Maybe<HeatUnit>;
  endUseElectricityMechVentPrecooling?: Maybe<HeatUnit>;
  endUseElectricityMechVentPreheating?: Maybe<HeatUnit>;
  endUseElectricityPV?: Maybe<HeatUnit>;
  endUseElectricityPlugLoads?: Maybe<HeatUnit>;
  endUseElectricityPoolHeater?: Maybe<HeatUnit>;
  endUseElectricityPoolPump?: Maybe<HeatUnit>;
  endUseElectricityRangeOven?: Maybe<HeatUnit>;
  endUseElectricityRefrigerator?: Maybe<HeatUnit>;
  endUseElectricityTelevision?: Maybe<HeatUnit>;
  endUseElectricityWellPump?: Maybe<HeatUnit>;
  endUseElectricityWholeHouseFan?: Maybe<HeatUnit>;
  endUseFuelOilClothesDryer?: Maybe<HeatUnit>;
  endUseFuelOilFireplace?: Maybe<HeatUnit>;
  endUseFuelOilGenerator?: Maybe<HeatUnit>;
  endUseFuelOilGrill?: Maybe<HeatUnit>;
  endUseFuelOilHeating?: Maybe<HeatUnit>;
  endUseFuelOilHotWater?: Maybe<HeatUnit>;
  endUseFuelOilLighting?: Maybe<HeatUnit>;
  endUseFuelOilMechVentPreheating?: Maybe<HeatUnit>;
  endUseFuelOilRangeOven?: Maybe<HeatUnit>;
  endUseNaturalGasClothesDryer?: Maybe<HeatUnit>;
  endUseNaturalGasFireplace?: Maybe<HeatUnit>;
  endUseNaturalGasGenerator?: Maybe<HeatUnit>;
  endUseNaturalGasGrill?: Maybe<HeatUnit>;
  endUseNaturalGasHeating?: Maybe<HeatUnit>;
  endUseNaturalGasHotTubHeater?: Maybe<HeatUnit>;
  endUseNaturalGasHotWater?: Maybe<HeatUnit>;
  endUseNaturalGasLighting?: Maybe<HeatUnit>;
  endUseNaturalGasMechVentPreheating?: Maybe<HeatUnit>;
  endUseNaturalGasPoolHeater?: Maybe<HeatUnit>;
  endUseNaturalGasRangeOven?: Maybe<HeatUnit>;
  endUsePropaneClothesDryer?: Maybe<HeatUnit>;
  endUsePropaneFireplace?: Maybe<HeatUnit>;
  endUsePropaneGenerator?: Maybe<HeatUnit>;
  endUsePropaneGrill?: Maybe<HeatUnit>;
  endUsePropaneHeating?: Maybe<HeatUnit>;
  endUsePropaneHotWater?: Maybe<HeatUnit>;
  endUsePropaneLighting?: Maybe<HeatUnit>;
  endUsePropaneMechVentPreheating?: Maybe<HeatUnit>;
  endUsePropaneRangeOven?: Maybe<HeatUnit>;
  endUseWoodCordClothesDryer?: Maybe<HeatUnit>;
  endUseWoodCordFireplace?: Maybe<HeatUnit>;
  endUseWoodCordGenerator?: Maybe<HeatUnit>;
  endUseWoodCordGrill?: Maybe<HeatUnit>;
  endUseWoodCordHeating?: Maybe<HeatUnit>;
  endUseWoodCordHotWater?: Maybe<HeatUnit>;
  endUseWoodCordLighting?: Maybe<HeatUnit>;
  endUseWoodCordMechVentPreheating?: Maybe<HeatUnit>;
  endUseWoodCordRangeOven?: Maybe<HeatUnit>;
  endUseWoodPelletsClothesDryer?: Maybe<HeatUnit>;
  endUseWoodPelletsFireplace?: Maybe<HeatUnit>;
  endUseWoodPelletsGenerator?: Maybe<HeatUnit>;
  endUseWoodPelletsGrill?: Maybe<HeatUnit>;
  endUseWoodPelletsHeating?: Maybe<HeatUnit>;
  endUseWoodPelletsHotWater?: Maybe<HeatUnit>;
  endUseWoodPelletsLighting?: Maybe<HeatUnit>;
  endUseWoodPelletsMechVentPreheating?: Maybe<HeatUnit>;
  endUseWoodPelletsRangeOven?: Maybe<HeatUnit>;
  fuelUseCoalTotal?: Maybe<HeatUnit>;
  fuelUseElectricityNet?: Maybe<HeatUnit>;
  fuelUseElectricityTotal?: Maybe<HeatUnit>;
  fuelUseFuelOilTotal?: Maybe<HeatUnit>;
  fuelUseNaturalGasTotal?: Maybe<HeatUnit>;
  fuelUsePropaneTotal?: Maybe<HeatUnit>;
  fuelUseWoodCordTotal?: Maybe<HeatUnit>;
  fuelUseWoodPelletsTotal?: Maybe<HeatUnit>;
  hotWaterClothesWasher?: Maybe<VolumeUnit>;
  hotWaterDishwasher?: Maybe<VolumeUnit>;
  hotWaterDistributionWaste?: Maybe<VolumeUnit>;
  hotWaterFixtures?: Maybe<VolumeUnit>;
  loadCoolingDelivered?: Maybe<HeatUnit>;
  loadHeatingDelivered?: Maybe<HeatUnit>;
  loadHotWaterDelivered?: Maybe<HeatUnit>;
  loadHotWaterDesuperheater?: Maybe<HeatUnit>;
  loadHotWaterSolarThermal?: Maybe<HeatUnit>;
  loadHotWaterTankLosses?: Maybe<HeatUnit>;
  peakElectricitySummerTotal?: Maybe<PowerUnit>;
  peakElectricityWinterTotal?: Maybe<PowerUnit>;
  peakLoadCoolingDelivered?: Maybe<HeatUnit>;
  peakLoadHeatingDelivered?: Maybe<HeatUnit>;
  simulationId: Scalars['ID'];
  unmetHoursCooling?: Maybe<TimeUnit>;
  unmetHoursHeating?: Maybe<TimeUnit>;
  validatedProfileAnnualResultId?: Maybe<Scalars['ID']>;
  validatedProfileId: Scalars['ID'];
};

export type AreaUnit = {
  __typename?: 'AreaUnit';
  squareFeet?: Maybe<Scalars['Float']>;
  squareMeters?: Maybe<Scalars['Float']>;
};

export type BaseBuildingProfile = {
  bathroomCount?: Maybe<Scalars['Float']>;
  bedroomCount?: Maybe<Scalars['Int']>;
  buildingProfileId?: Maybe<Scalars['ID']>;
  buildingType?: Maybe<Scalars['String']>;
  conditionedFloorAreaSqFt?: Maybe<Scalars['Float']>;
  coolingSystems?: Maybe<Array<Maybe<CoolingSystem>>>;
  floorsAboveGrade?: Maybe<Scalars['Float']>;
  foundationType?: Maybe<Scalars['String']>;
  hasAttic?: Maybe<Scalars['Boolean']>;
  hasBasement?: Maybe<Scalars['Boolean']>;
  hasCrawlspace?: Maybe<Scalars['Boolean']>;
  hasEvCharger?: Maybe<Scalars['Boolean']>;
  hasHottub?: Maybe<Scalars['Boolean']>;
  hasPool?: Maybe<Scalars['Boolean']>;
  hasSolar?: Maybe<Scalars['Boolean']>;
  hasStorageBattery?: Maybe<Scalars['Boolean']>;
  heatingSystems?: Maybe<Array<Maybe<HeatingSystem>>>;
  homeOwnerAssessedLeakage?: Maybe<Scalars['Float']>;
  homeOwnerAssessedTemp?: Maybe<Scalars['Float']>;
  isBasementFinished?: Maybe<Scalars['Boolean']>;
  roofShadinessFactor?: Maybe<Scalars['Float']>;
  servicePanelSize?: Maybe<Scalars['Int']>;
  stoveTopType?: Maybe<Scalars['String']>;
  waterHeater?: Maybe<WaterHeater>;
  yearBuilt?: Maybe<Scalars['Int']>;
  yearBuiltEffective?: Maybe<Scalars['Int']>;
};

export type BuildingProfile = BaseBuildingProfile & {
  __typename?: 'BuildingProfile';
  bathroomCount?: Maybe<Scalars['Float']>;
  bedroomCount?: Maybe<Scalars['Int']>;
  buildingProfileId?: Maybe<Scalars['ID']>;
  buildingType?: Maybe<Scalars['String']>;
  conditionedFloorAreaSqFt?: Maybe<Scalars['Float']>;
  coolingSystems?: Maybe<Array<Maybe<CoolingSystem>>>;
  floorsAboveGrade?: Maybe<Scalars['Float']>;
  foundationType?: Maybe<Scalars['String']>;
  hasAttic?: Maybe<Scalars['Boolean']>;
  hasBasement?: Maybe<Scalars['Boolean']>;
  hasCrawlspace?: Maybe<Scalars['Boolean']>;
  hasEvCharger?: Maybe<Scalars['Boolean']>;
  hasHottub?: Maybe<Scalars['Boolean']>;
  hasPool?: Maybe<Scalars['Boolean']>;
  hasSolar?: Maybe<Scalars['Boolean']>;
  hasStorageBattery?: Maybe<Scalars['Boolean']>;
  heatingSystems?: Maybe<Array<Maybe<HeatingSystem>>>;
  homeOwnerAssessedLeakage?: Maybe<Scalars['Float']>;
  homeOwnerAssessedTemp?: Maybe<Scalars['Float']>;
  isBasementFinished?: Maybe<Scalars['Boolean']>;
  roofShadinessFactor?: Maybe<Scalars['Float']>;
  servicePanelSize?: Maybe<Scalars['Int']>;
  stoveTopType?: Maybe<Scalars['String']>;
  waterHeater?: Maybe<WaterHeater>;
  yearBuilt?: Maybe<Scalars['Int']>;
  yearBuiltEffective?: Maybe<Scalars['Int']>;
};

export type Bundle = {
  __typename?: 'Bundle';
  active: Scalars['Boolean'];
  activeEndDate?: Maybe<Scalars['Date']>;
  activeStartDate: Scalars['Date'];
  allEquipment?: Maybe<Array<Maybe<Equipment>>>;
  bundleId: Scalars['ID'];
  bundleRule?: Maybe<BundleRule>;
  bundleType: BundleType;
  cost: Scalars['Float'];
  costInCents: Scalars['Int'];
  costType: CostType;
  createdAt: Scalars['Date'];
  designDbId?: Maybe<Scalars['ID']>;
  displayName: Scalars['String'];
  equipmentCost?: Maybe<Scalars['Float']>;
  equipmentCostInCents?: Maybe<Scalars['Int']>;
  incentives?: Maybe<Array<Maybe<Incentive>>>;
  markupPercentage: Scalars['Int'];
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  priceInCents?: Maybe<Scalars['Int']>;
  productCategory: ProductCategory;
  proposalDetails?: Maybe<Scalars['String']>;
  standardLaborCost?: Maybe<Scalars['Float']>;
  standardLaborCostInCents?: Maybe<Scalars['Int']>;
  standardMaterialCost?: Maybe<Scalars['Float']>;
  standardMaterialCostInCents?: Maybe<Scalars['Int']>;
  unitOfMeasure?: Maybe<UnitOfMeasure>;
  updatedAt: Scalars['Date'];
};

export type BundleFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  bundleId?: InputMaybe<Array<Scalars['ID']>>;
  designDbId?: InputMaybe<Array<Scalars['ID']>>;
};

export type BundleInput = {
  activeEndDate?: InputMaybe<Scalars['Date']>;
  activeStartDate?: InputMaybe<Scalars['Date']>;
  bundleId?: InputMaybe<Scalars['ID']>;
  bundleRuleType?: InputMaybe<BundleRuleType>;
  bundleType?: InputMaybe<BundleType>;
  costInCents?: InputMaybe<Scalars['Int']>;
  costType?: InputMaybe<CostType>;
  designDbId?: InputMaybe<Scalars['ID']>;
  displayName?: InputMaybe<Scalars['String']>;
  equipmentCostInCents?: InputMaybe<Scalars['Int']>;
  /** The IDs for equipment to associate with this bundle on creation or updating, if any, fully replacing existing associations. An empty array will remove all existing associations. */
  equipmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The IDs for incentives to associate with this bundle on creation or updating, if any, fully replacing existing associations. An empty array will remove all existing associations. */
  incentiveIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  markupPercentage?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  proposalDetails?: InputMaybe<Scalars['String']>;
  standardLaborCostInCents?: InputMaybe<Scalars['Int']>;
  standardMaterialCostInCents?: InputMaybe<Scalars['Int']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
};

export type BundleRule = {
  __typename?: 'BundleRule';
  bundleRuleId: Scalars['ID'];
  bundleRuleType: BundleRuleType;
  bundles?: Maybe<Array<Bundle>>;
  createdAt: Scalars['DateTime'];
  error: Scalars['String'];
  reason: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BundleRuleInput = {
  bundleIds?: InputMaybe<Array<Scalars['ID']>>;
  bundleRuleId?: InputMaybe<Scalars['ID']>;
  bundleRuleType?: InputMaybe<BundleRuleType>;
  error?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export enum BundleRuleType {
  EvChargerOutlet = 'EV_CHARGER_OUTLET',
  HeatPumpWaterHeater_50Gal = 'HEAT_PUMP_WATER_HEATER_50_GAL',
  HeatPumpWaterHeater_66Gal = 'HEAT_PUMP_WATER_HEATER_66_GAL',
  HeatPumpWaterHeater_80Gal = 'HEAT_PUMP_WATER_HEATER_80_GAL',
  Solar = 'SOLAR'
}

export enum BundleType {
  Complexity = 'COMPLEXITY',
  Equipment = 'EQUIPMENT'
}

export enum Complexity {
  High = 'HIGH',
  Medium = 'MEDIUM',
  NotSet = 'NOT_SET',
  Standard = 'STANDARD'
}

export type CoolingSystem = {
  __typename?: 'CoolingSystem';
  coolingSystemId: Scalars['ID'];
  coolingSystemType: Scalars['String'];
  yearInstalled?: Maybe<Scalars['Int']>;
};

export type CoolingSystemInput = {
  coolingSystemId?: InputMaybe<Scalars['ID']>;
  coolingSystemType?: InputMaybe<Scalars['String']>;
  yearInstalled?: InputMaybe<Scalars['Int']>;
};

export enum CostType {
  Fixed = 'FIXED',
  QuantityBased = 'QUANTITY_BASED'
}

export type Customer = {
  __typename?: 'Customer';
  addresses?: Maybe<Array<Address>>;
  createdAt: Scalars['Date'];
  customerId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hubspotContactId?: Maybe<Scalars['ID']>;
  isTest: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  visits?: Maybe<Array<Visit>>;
};

export type CustomerInput = {
  customerId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hubspotContactId?: InputMaybe<Scalars['ID']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['ID']>;
};

export type CustomerPortal = {
  __typename?: 'CustomerPortal';
  address: Address;
  customer: Customer;
  customerPortalId: Scalars['ID'];
  customerPortalUrl: Scalars['String'];
  deals?: Maybe<Array<Maybe<Deal>>>;
  proposalId: Scalars['ID'];
  token: Scalars['String'];
  visit: Visit;
};

export type CustomerPortalInput = {
  proposalId: Scalars['ID'];
};

export type CustomerPortalQueryInput = {
  token: Scalars['String'];
};

export type Deal = {
  __typename?: 'Deal';
  amount?: Maybe<Scalars['String']>;
  hsObjectId?: Maybe<Scalars['ID']>;
  hubspotOwnerId?: Maybe<Scalars['ID']>;
  installDates?: Maybe<Scalars['String']>;
  installEndDate?: Maybe<Scalars['String']>;
  opsCompleteDate?: Maybe<Scalars['String']>;
  walkthroughDate?: Maybe<Scalars['String']>;
};

export type DeleteElectrificationGoalResponse = {
  __typename?: 'DeleteElectrificationGoalResponse';
  electrificationGoalId: Scalars['ID'];
};

export type Design = {
  __typename?: 'Design';
  accessRestrictionsMechanicalRoom?: Maybe<Scalars['Boolean']>;
  additionalSolarWatts?: Maybe<Scalars['Int']>;
  airSealInsulationSqFt?: Maybe<Scalars['Int']>;
  atticFrameFloorInsulationSqFt?: Maybe<Scalars['Int']>;
  basementRimJoistInsulationSqFt?: Maybe<Scalars['Int']>;
  basementWallInsulationSqFt?: Maybe<Scalars['Int']>;
  bathVentingComplexity?: Maybe<Complexity>;
  batteryStorageElectricalRunComplexity?: Maybe<Complexity>;
  branchInsulatedRuns?: Maybe<Scalars['Int']>;
  branchUninsulatedRuns?: Maybe<Scalars['Int']>;
  cookingRangeElectricRunComplexity?: Maybe<Complexity>;
  cost?: Maybe<Scalars['Float']>;
  costInCents?: Maybe<Scalars['Int']>;
  crawlspaceRimJoistInsulationSqFt?: Maybe<Scalars['Int']>;
  crawlspaceWallInsulationSqFt?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  designBundles?: Maybe<Array<DesignBundle>>;
  designId: Scalars['ID'];
  designIncentives?: Maybe<Array<DesignIncentive>>;
  designType: DesignType;
  evChargerElectricRunComplexity?: Maybe<Complexity>;
  existingSolarWatts?: Maybe<Scalars['Int']>;
  exteriorWallInsulationSqFt?: Maybe<Scalars['Int']>;
  garageInsulationSqFt?: Maybe<Scalars['Int']>;
  hasCookingRangeOutlet?: Maybe<Scalars['Boolean']>;
  hvacElectricRunComplexity?: Maybe<Complexity>;
  hvacLineSetComplexity?: Maybe<Complexity>;
  hvacLocation?: Maybe<EquipmentLocation>;
  kneeWallInsulationSqFt?: Maybe<Scalars['Int']>;
  margin?: Maybe<Scalars['Float']>;
  marginInCents?: Maybe<Scalars['Int']>;
  marginPercentage?: Maybe<Scalars['Int']>;
  markupPercentage?: Maybe<Scalars['Int']>;
  mechanicalRoomCount?: Maybe<Scalars['Int']>;
  mitsubishiDsbUrl?: Maybe<Scalars['String']>;
  otherFrameFloorInsulationSqFt?: Maybe<Scalars['Int']>;
  pdfUrl?: Maybe<Scalars['String']>;
  potentialForSolar?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  priceInCents?: Maybe<Scalars['Int']>;
  productCategories?: Maybe<Array<DesignProductCategory>>;
  proposal: Proposal;
  retoolDesignEnergyMeasures?: Maybe<Scalars['JSON']>;
  retoolDesignJson?: Maybe<Scalars['JSON']>;
  solarComplexity?: Maybe<Complexity>;
  solarDesignImageUrl?: Maybe<Scalars['String']>;
  solarTrenchDistanceFt?: Maybe<Scalars['Int']>;
  source: DesignSource;
  totalCost?: Maybe<Scalars['Float']>;
  totalCostInCents?: Maybe<Scalars['Int']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalPriceInCents?: Maybe<Scalars['Int']>;
  trunkInsulatedFt?: Maybe<Scalars['Int']>;
  trunkUninsulatedFt?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  waterHeaterAccessRestrictions?: Maybe<Scalars['Boolean']>;
  waterHeaterLocation?: Maybe<EquipmentLocation>;
};

export type DesignBundle = {
  __typename?: 'DesignBundle';
  /** Other fields can be accessed through the bundle */
  bundle: Bundle;
  bundleId: Scalars['ID'];
  /** These fields are pulled from the designBundle */
  designBundleId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  totalCost: Scalars['Float'];
  totalCostInCents: Scalars['Int'];
  totalPrice: Scalars['Float'];
  totalPriceInCents: Scalars['Int'];
};

export type DesignBundleInput = {
  bundleDesignDbId?: InputMaybe<Scalars['ID']>;
  bundleId?: InputMaybe<Scalars['ID']>;
  designBundleId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type DesignIncentive = {
  __typename?: 'DesignIncentive';
  /** These fields are pulled from the designIncentive */
  designIncentiveId: Scalars['ID'];
  /** Other fields can be accessed through the incentive */
  incentive: Incentive;
  incentiveId: Scalars['ID'];
  totalAmount: Scalars['Float'];
  totalAmountInCents: Scalars['Int'];
};

export type DesignInput = {
  accessRestrictionsMechanicalRoom?: InputMaybe<Scalars['Boolean']>;
  additionalSolarWatts?: InputMaybe<Scalars['Int']>;
  airSealInsulationSqFt?: InputMaybe<Scalars['Int']>;
  atticFrameFloorInsulationSqFt?: InputMaybe<Scalars['Int']>;
  basementRimJoistInsulationSqFt?: InputMaybe<Scalars['Int']>;
  basementWallInsulationSqFt?: InputMaybe<Scalars['Int']>;
  bathVentingComplexity?: InputMaybe<Complexity>;
  batteryStorageElectricalRunComplexity?: InputMaybe<Complexity>;
  branchInsulatedRuns?: InputMaybe<Scalars['Int']>;
  branchUninsulatedRuns?: InputMaybe<Scalars['Int']>;
  bundleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  cookingRangeElectricRunComplexity?: InputMaybe<Complexity>;
  crawlspaceRimJoistInsulationSqFt?: InputMaybe<Scalars['Int']>;
  crawlspaceWallInsulationSqFt?: InputMaybe<Scalars['Int']>;
  designBundles?: InputMaybe<Array<InputMaybe<DesignBundleInput>>>;
  designId?: InputMaybe<Scalars['ID']>;
  designType?: InputMaybe<DesignType>;
  evChargerElectricRunComplexity?: InputMaybe<Complexity>;
  existingSolarWatts?: InputMaybe<Scalars['Int']>;
  exteriorWallInsulationSqFt?: InputMaybe<Scalars['Int']>;
  garageInsulationSqFt?: InputMaybe<Scalars['Int']>;
  hasCookingRangeOutlet?: InputMaybe<Scalars['Boolean']>;
  hvacElectricRunComplexity?: InputMaybe<Complexity>;
  hvacLineSetComplexity?: InputMaybe<Complexity>;
  hvacLocation?: InputMaybe<EquipmentLocation>;
  incentiveIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  kneeWallInsulationSqFt?: InputMaybe<Scalars['Int']>;
  mechanicalRoomCount?: InputMaybe<Scalars['Int']>;
  mitsubishiDsbUrl?: InputMaybe<Scalars['String']>;
  otherFrameFloorInsulationSqFt?: InputMaybe<Scalars['Int']>;
  pdfUrl?: InputMaybe<Scalars['String']>;
  potentialForSolar?: InputMaybe<Scalars['Boolean']>;
  proposalId?: InputMaybe<Scalars['ID']>;
  retoolDesignJson?: InputMaybe<Scalars['JSON']>;
  solarComplexity?: InputMaybe<Complexity>;
  solarDesignImageUrl?: InputMaybe<Scalars['String']>;
  solarTrenchDistanceFt?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<DesignSource>;
  trunkInsulatedFt?: InputMaybe<Scalars['Int']>;
  trunkUninsulatedFt?: InputMaybe<Scalars['Int']>;
  visitId?: InputMaybe<Scalars['ID']>;
  waterHeaterAccessRestrictions?: InputMaybe<Scalars['Boolean']>;
  waterHeaterLocation?: InputMaybe<EquipmentLocation>;
};

export type DesignProductCategory = {
  __typename?: 'DesignProductCategory';
  designBundles?: Maybe<Array<DesignBundle>>;
  designIncentives?: Maybe<Array<DesignIncentive>>;
  incentives?: Maybe<Array<Incentive>>;
  productCategory: ProductCategory;
  totalCost: Scalars['Float'];
  totalCostInCents: Scalars['Int'];
  totalDiscount: Scalars['Float'];
  totalDiscountInCents: Scalars['Int'];
  totalPrice: Scalars['Float'];
  totalPriceInCents: Scalars['Int'];
  totalRebate: Scalars['Float'];
  totalRebateInCents: Scalars['Int'];
  totalTaxCredit: Scalars['Float'];
  totalTaxCreditInCents: Scalars['Int'];
};

export enum DesignSource {
  /** From the AWS Personalize Recommender */
  AwsPersonalizeV1 = 'AWS_PERSONALIZE_V1',
  /** Design created by a designer */
  Designer = 'DESIGNER',
  /** Design solution from rules applied in Retool Design Workbench app */
  RetoolDesignWorkbench = 'RETOOL_DESIGN_WORKBENCH',
  /** Design created by roadmap-backend */
  RoadmapBackend = 'ROADMAP_BACKEND'
}

export enum DesignType {
  /** Proposed designs are created by designers and may be modified */
  Proposed = 'PROPOSED',
  /** Recommended designs are created by a recommender, and are not editable */
  Recommended = 'RECOMMENDED'
}

export type ElectrificationEngagement = {
  __typename?: 'ElectrificationEngagement';
  electricalServiceUpgrade?: Maybe<Scalars['Boolean']>;
  electrificationEngagementId: Scalars['ID'];
  heatPumpHvac?: Maybe<Scalars['Boolean']>;
  heatPumpWaterHeater?: Maybe<Scalars['Boolean']>;
  homeVentilation?: Maybe<Scalars['Boolean']>;
  inductionStove?: Maybe<Scalars['Boolean']>;
  insulation?: Maybe<Scalars['Boolean']>;
  interactionCount: Scalars['Int'];
  solar?: Maybe<Scalars['Boolean']>;
  storageBattery?: Maybe<Scalars['Boolean']>;
  vehicleCharger?: Maybe<Scalars['Boolean']>;
  visit: Visit;
};

export type ElectrificationEngagementInput = {
  electricalServiceUpgrade?: InputMaybe<Scalars['Boolean']>;
  electrificationEngagementId?: InputMaybe<Scalars['ID']>;
  heatPumpHvac?: InputMaybe<Scalars['Boolean']>;
  heatPumpWaterHeater?: InputMaybe<Scalars['Boolean']>;
  homeVentilation?: InputMaybe<Scalars['Boolean']>;
  inductionStove?: InputMaybe<Scalars['Boolean']>;
  insulation?: InputMaybe<Scalars['Boolean']>;
  solar?: InputMaybe<Scalars['Boolean']>;
  storageBattery?: InputMaybe<Scalars['Boolean']>;
  vehicleCharger?: InputMaybe<Scalars['Boolean']>;
};

export type ElectrificationEngagements = {
  __typename?: 'ElectrificationEngagements';
  averageInteractions?: Maybe<Scalars['Float']>;
  electrificationEngagements?: Maybe<Array<ElectrificationEngagement>>;
};

export type ElectrificationGoal = {
  __typename?: 'ElectrificationGoal';
  electrificationGoalId: Scalars['ID'];
  electrificationGoalText: Scalars['String'];
};

export type ElectrificationGoalInput = {
  electrificationGoalId?: InputMaybe<Scalars['ID']>;
  electrificationGoalText: Scalars['String'];
};

export type EnergyUsage = {
  __typename?: 'EnergyUsage';
  co2Tons?: Maybe<Scalars['Float']>;
  electrifiedEnergyUsageKwh?: Maybe<Scalars['Float']>;
  energyEfficiencyImprovement?: Maybe<Scalars['Float']>;
  energyUseIntensityScore?: Maybe<Scalars['Float']>;
  solarPotential?: Maybe<SolarPotential>;
};

export type Equipment = {
  __typename?: 'Equipment';
  bundles?: Maybe<Array<Maybe<Bundle>>>;
  description: Scalars['String'];
  designDbId?: Maybe<Scalars['ID']>;
  equipmentClass: EquipmentClass;
  equipmentDisplayName: Scalars['String'];
  equipmentId: Scalars['ID'];
  equipmentMake: EquipmentMake;
  equipmentMakeSeries?: Maybe<EquipmentMakeSeries>;
  model: Scalars['String'];
};

export type EquipmentClass = {
  __typename?: 'EquipmentClass';
  equipmentClassId: Scalars['ID'];
  equipmentClassType: EquipmentClassType;
  name: Scalars['String'];
};

export type EquipmentClassInput = {
  equipmentClassId?: InputMaybe<Scalars['ID']>;
  equipmentClassType?: InputMaybe<EquipmentClassType>;
  name?: InputMaybe<Scalars['String']>;
};

export enum EquipmentClassType {
  AirHandler = 'AIR_HANDLER',
  Battery = 'BATTERY',
  BranchBox = 'BRANCH_BOX',
  BranchBoxEnclosure = 'BRANCH_BOX_ENCLOSURE',
  CasedCoil = 'CASED_COIL',
  CeilingUnit = 'CEILING_UNIT',
  Condenser = 'CONDENSER',
  Controls = 'CONTROLS',
  Electrical = 'ELECTRICAL',
  EnergyMonitor = 'ENERGY_MONITOR',
  ExhaustVenting = 'EXHAUST_VENTING',
  FloorUnit = 'FLOOR_UNIT',
  GasFurnace = 'GAS_FURNACE',
  Humidifier = 'HUMIDIFIER',
  HvacAccessories = 'HVAC_ACCESSORIES',
  Panels = 'PANELS',
  Plumbing = 'PLUMBING',
  RackSystem = 'RACK_SYSTEM',
  StripHeater = 'STRIP_HEATER',
  Ventilation = 'VENTILATION',
  WallHead = 'WALL_HEAD',
  WaterHeater = 'WATER_HEATER'
}

export type EquipmentFilter = {
  designDbId?: InputMaybe<Array<Scalars['ID']>>;
  equipmentId?: InputMaybe<Array<Scalars['ID']>>;
};

export type EquipmentInput = {
  /** The IDs for bundles to associate with this equipment on creation or updating, if any, fully replacing existing associations. An empty array will remove all existing associations. */
  bundleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  designDbId?: InputMaybe<Scalars['ID']>;
  equipmentClassId?: InputMaybe<Scalars['ID']>;
  equipmentId?: InputMaybe<Scalars['ID']>;
  equipmentMakeId?: InputMaybe<Scalars['ID']>;
  equipmentMakeSeriesId?: InputMaybe<Scalars['ID']>;
  model?: InputMaybe<Scalars['String']>;
};

export enum EquipmentLocation {
  Attic = 'ATTIC',
  Closet = 'CLOSET',
  Crawlspace = 'CRAWLSPACE',
  FinishedBasement = 'FINISHED_BASEMENT',
  Garage = 'GARAGE',
  InWall = 'IN_WALL',
  MechanicalRoom = 'MECHANICAL_ROOM',
  NotSet = 'NOT_SET',
  Outdoors = 'OUTDOORS',
  UnfinishedBasement = 'UNFINISHED_BASEMENT'
}

export type EquipmentMake = {
  __typename?: 'EquipmentMake';
  equipmentMakeId?: Maybe<Scalars['ID']>;
  equipmentMakeSeries?: Maybe<Array<Maybe<EquipmentMakeSeries>>>;
  name?: Maybe<Scalars['String']>;
};

export type EquipmentMakeInput = {
  equipmentMakeId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EquipmentMakeSeries = {
  __typename?: 'EquipmentMakeSeries';
  equipmentMake: EquipmentMake;
  equipmentMakeSeriesId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type EquipmentMakeSeriesInput = {
  equipmentMakeId?: InputMaybe<Scalars['ID']>;
  equipmentMakeSeriesId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FlowRateUnit = {
  __typename?: 'FlowRateUnit';
  cubicFeetPerMinute?: Maybe<Scalars['Float']>;
};

export type HeatUnit = {
  __typename?: 'HeatUnit';
  btus?: Maybe<Scalars['Float']>;
  kiloBtus?: Maybe<Scalars['Float']>;
  kwh?: Maybe<Scalars['Float']>;
  megaBtus?: Maybe<Scalars['Float']>;
  therms?: Maybe<Scalars['Float']>;
};

export type HeatingSystem = {
  __typename?: 'HeatingSystem';
  heatingSystemFuelType: Scalars['String'];
  heatingSystemId: Scalars['ID'];
  heatingSystemType: Scalars['String'];
  yearInstalled?: Maybe<Scalars['Int']>;
};

export type HeatingSystemInput = {
  heatingSystemFuelType?: InputMaybe<Scalars['String']>;
  heatingSystemId?: InputMaybe<Scalars['ID']>;
  heatingSystemType?: InputMaybe<Scalars['String']>;
  yearInstalled?: InputMaybe<Scalars['Int']>;
};

export type HpxmlResult = {
  __typename?: 'HpxmlResult';
  designLoadsCoolingLatentDucts?: Maybe<PowerUnit>;
  designLoadsCoolingLatentInfiltrationVentilation?: Maybe<PowerUnit>;
  designLoadsCoolingLatentInternalGains?: Maybe<PowerUnit>;
  designLoadsCoolingLatentTotal?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleCeilings?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleDoors?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleDucts?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleFloors?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleInfiltrationVentilation?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleInternalGains?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleRoofs?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleSkylights?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleSlabs?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleTotal?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleWalls?: Maybe<PowerUnit>;
  designLoadsCoolingSensibleWindows?: Maybe<PowerUnit>;
  designLoadsHeatingCeilings?: Maybe<PowerUnit>;
  designLoadsHeatingDoors?: Maybe<PowerUnit>;
  designLoadsHeatingDucts?: Maybe<PowerUnit>;
  designLoadsHeatingFloors?: Maybe<PowerUnit>;
  designLoadsHeatingInfiltrationVentilation?: Maybe<PowerUnit>;
  designLoadsHeatingRoofs?: Maybe<PowerUnit>;
  designLoadsHeatingSkylights?: Maybe<PowerUnit>;
  designLoadsHeatingSlabs?: Maybe<PowerUnit>;
  designLoadsHeatingTotal?: Maybe<PowerUnit>;
  designLoadsHeatingWalls?: Maybe<PowerUnit>;
  designLoadsHeatingWindows?: Maybe<PowerUnit>;
  enclosureCeilingAreaThermalBoundary?: Maybe<AreaUnit>;
  enclosureDoorArea?: Maybe<AreaUnit>;
  enclosureDuctAreaUnconditioned?: Maybe<AreaUnit>;
  enclosureFloorAreaConditioned?: Maybe<AreaUnit>;
  enclosureFloorAreaLighting?: Maybe<AreaUnit>;
  enclosureFoundationWallAreaExterior?: Maybe<AreaUnit>;
  enclosureRimJoistArea?: Maybe<AreaUnit>;
  enclosureRoofArea?: Maybe<AreaUnit>;
  enclosureSlabExposedPerimeterThermalBoundary?: Maybe<LengthUnit>;
  enclosureWallAreaExterior?: Maybe<AreaUnit>;
  enclosureWallAreaThermalBoundary?: Maybe<AreaUnit>;
  enclosureWindowArea?: Maybe<AreaUnit>;
  primarySystemsCoolingCapacity?: Maybe<PowerUnit>;
  primarySystemsHeatPumpBackupCapacity?: Maybe<PowerUnit>;
  primarySystemsHeatingCapacity?: Maybe<PowerUnit>;
  secondarySystemsCoolingCapacity?: Maybe<PowerUnit>;
  secondarySystemsHeatPumpBackupCapacity?: Maybe<PowerUnit>;
  secondarySystemsHeatingCapacity?: Maybe<PowerUnit>;
  simulationId: Scalars['ID'];
  systemsCoolingCapacity?: Maybe<PowerUnit>;
  systemsHeatPumpBackupCapacity?: Maybe<PowerUnit>;
  systemsHeatingCapacity?: Maybe<PowerUnit>;
  systemsMechanicalVentilationFlowRate?: Maybe<FlowRateUnit>;
  systemsWaterHeaterTankVolume?: Maybe<VolumeUnit>;
  validatedProfileHpxmlResultId: Scalars['ID'];
  validatedProfileId: Scalars['ID'];
};

export type HubspotDeal = {
  __typename?: 'HubspotDeal';
  id: Scalars['ID'];
};

export type Incentive = {
  __typename?: 'Incentive';
  activeEndDate?: Maybe<Scalars['Date']>;
  activeStartDate: Scalars['Date'];
  bundles?: Maybe<Array<Maybe<Bundle>>>;
  designDbId?: Maybe<Scalars['ID']>;
  incentiveId: Scalars['ID'];
  incentiveName: Scalars['String'];
  incentiveProgram?: Maybe<IncentiveProgram>;
  incentiveType: IncentiveType;
  maximumAmount?: Maybe<Scalars['Float']>;
  maximumAmountInCents?: Maybe<Scalars['Int']>;
  maximumPercentage?: Maybe<Scalars['Int']>;
  paymentMethodType: PaymentType;
  productCategory: ProductCategory;
  quantityMultiplierInCents?: Maybe<Scalars['Int']>;
};

export enum IncentiveAgencyType {
  City = 'CITY',
  Company = 'COMPANY',
  Country = 'COUNTRY',
  County = 'COUNTY',
  State = 'STATE',
  Utility = 'UTILITY'
}

export type IncentiveBundleInput = {
  bundleId: Scalars['ID'];
  incentiveId: Scalars['ID'];
};

export type IncentiveBundleResponse = {
  __typename?: 'IncentiveBundleResponse';
  bundle?: Maybe<Bundle>;
  incentive?: Maybe<Incentive>;
  incentiveBundleId?: Maybe<Scalars['ID']>;
};

export type IncentiveInput = {
  activeEndDate?: InputMaybe<Scalars['Date']>;
  activeStartDate?: InputMaybe<Scalars['Date']>;
  /** The IDs for bundles to associate with this incentive on creation or updating, if any, fully replacing existing associations. An empty array will remove all existing associations. */
  bundleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  designDbId?: InputMaybe<Scalars['ID']>;
  incentiveId?: InputMaybe<Scalars['ID']>;
  incentiveName?: InputMaybe<Scalars['String']>;
  incentiveProgramId?: InputMaybe<Scalars['ID']>;
  incentiveType?: InputMaybe<IncentiveType>;
  maximumAmountInCents?: InputMaybe<Scalars['Int']>;
  maximumPercentage?: InputMaybe<Scalars['Int']>;
  paymentMethodType?: InputMaybe<PaymentType>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  quantityMultiplierInCents?: InputMaybe<Scalars['Int']>;
};

export type IncentiveProgram = {
  __typename?: 'IncentiveProgram';
  activeEndDate?: Maybe<Scalars['Date']>;
  activeStartDate: Scalars['Date'];
  incentiveAgency: Scalars['String'];
  incentiveAgencyLocation: Scalars['String'];
  incentiveAgencyType: IncentiveAgencyType;
  incentiveProgramId: Scalars['ID'];
  incentiveProgramName: Scalars['String'];
  incentiveProgramWebsiteUrl?: Maybe<Scalars['String']>;
  incentives: Array<Maybe<Incentive>>;
};

export type IncentiveProgramInput = {
  activeEndDate?: InputMaybe<Scalars['Date']>;
  activeStartDate?: InputMaybe<Scalars['Date']>;
  incentiveAgency?: InputMaybe<Scalars['String']>;
  incentiveAgencyLocation?: InputMaybe<Scalars['String']>;
  incentiveAgencyType?: InputMaybe<IncentiveAgencyType>;
  incentiveProgramId?: InputMaybe<Scalars['ID']>;
  incentiveProgramName?: InputMaybe<Scalars['String']>;
  incentiveProgramWebsiteUrl?: InputMaybe<Scalars['String']>;
};

export enum IncentiveType {
  Discount = 'DISCOUNT',
  Rebate = 'REBATE',
  TaxCredit = 'TAX_CREDIT'
}

export type LeadSource = {
  __typename?: 'LeadSource';
  leadSourceId: Scalars['ID'];
  leadSourceText?: Maybe<Scalars['String']>;
  visits?: Maybe<Array<Maybe<Visit>>>;
};

export type LeadSourceInput = {
  leadSourceId?: InputMaybe<Scalars['ID']>;
  leadSourceText: Scalars['String'];
};

export type LengthUnit = {
  __typename?: 'LengthUnit';
  feet?: Maybe<Scalars['Float']>;
  meters?: Maybe<Scalars['Float']>;
};

export type LocationInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addIncentiveBundle: IncentiveBundleResponse;
  deleteElectrificationGoal?: Maybe<DeleteElectrificationGoalResponse>;
  deleteIncentiveBundle: IncentiveBundleResponse;
  saveAddress: Address;
  /** Bulk save mutation for addresses */
  saveAddresses: SaveAddressesResponse;
  saveBundle: SaveBundleResult;
  saveBundleRule: BundleRule;
  saveBundleRules: Array<BundleRule>;
  saveBundles: SaveBundlesResult;
  /** mutation to save one customer */
  saveCustomer: Customer;
  saveCustomerPortal?: Maybe<CustomerPortal>;
  /** Mutation to create proposal and create/select design */
  saveCustomerProposal: Proposal;
  /** Bulk save mutation for customers */
  saveCustomers: SaveCustomersResponse;
  saveDesign: Design;
  saveDesignBundles?: Maybe<Array<DesignBundle>>;
  saveElectrificationEngagement: ElectrificationEngagement;
  saveElectrificationGoals: SaveElectrificationGoalsResponse;
  saveEquipment: SaveEquipmentResponse;
  saveEquipmentClasses: SaveEquipmentClassResponse;
  saveEquipmentMake: EquipmentMake;
  saveEquipmentMakeSeries: Array<Maybe<EquipmentMakeSeries>>;
  saveEquipmentMakes: SaveEquipmentMakeResponse;
  saveIncentive: SaveIncentiveResponse;
  saveIncentiveProgram: IncentiveProgram;
  saveIncentivePrograms: SaveIncentiveProgramsResponse;
  saveIncentives: SaveIncentivesResponse;
  saveLeadSource: LeadSource;
  saveLeadSources?: Maybe<SaveLeadSourcesResponse>;
  saveOneEquipment: Equipment;
  savePhotos: SavePhotosResponse;
  saveProductCategories: SaveProductCategoriesResponse;
  saveProductCategory: SaveProductCategoryResponse;
  saveProposal?: Maybe<Proposal>;
  saveProposalCategories: SaveProposalCategoriesResponse;
  saveProposalCategory: SaveProposalCategoryResponse;
  saveProposals: Array<Maybe<Proposal>>;
  saveReasons: SaveReasonsResponse;
  /** mutation to save one referral */
  saveReferral: Referral;
  /** Bulk save mutation for referrals */
  saveReferrals: SaveReferralsResponse;
  saveSalesIntakeForm: SaveBuildingProfileResult;
  saveUnitOfMeasure?: Maybe<UnitOfMeasure>;
  saveUnitsOfMeasure?: Maybe<Array<Maybe<UnitOfMeasure>>>;
  /**
   * Save customer and sales validated profiles from the property profile form.
   * This will create a new validated building profile in the platform schema.
   * New visits are created if a visitId is not provided.
   */
  saveValidatedBuildingProfile: SaveBuildingProfileResult;
  saveVideos: SaveVideosResponse;
  /** Create or update a visit */
  saveVisit: Visit;
  /**
   * Mutation to create a Hubspot Deal and Hubspot Contact (if needed)
   * for a given visit. Much of this logic is called after saveVisit.
   */
  syncVisitToHubspot: SyncVisitToHubspotResult;
};


export type MutationAddIncentiveBundleArgs = {
  input: IncentiveBundleInput;
};


export type MutationDeleteElectrificationGoalArgs = {
  electrificationGoalId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteIncentiveBundleArgs = {
  input: IncentiveBundleInput;
};


export type MutationSaveAddressArgs = {
  input: AddressInput;
};


export type MutationSaveAddressesArgs = {
  input: Array<AddressInput>;
};


export type MutationSaveBundleArgs = {
  input: BundleInput;
};


export type MutationSaveBundleRuleArgs = {
  input: BundleRuleInput;
};


export type MutationSaveBundleRulesArgs = {
  input: Array<BundleRuleInput>;
};


export type MutationSaveBundlesArgs = {
  input: Array<BundleInput>;
};


export type MutationSaveCustomerArgs = {
  input: CustomerInput;
};


export type MutationSaveCustomerPortalArgs = {
  input?: InputMaybe<CustomerPortalInput>;
};


export type MutationSaveCustomerProposalArgs = {
  input: SaveCustomerProposalInput;
};


export type MutationSaveCustomersArgs = {
  input: Array<CustomerInput>;
};


export type MutationSaveDesignArgs = {
  input: DesignInput;
};


export type MutationSaveDesignBundlesArgs = {
  input: Array<DesignBundleInput>;
};


export type MutationSaveElectrificationEngagementArgs = {
  input: ElectrificationEngagementInput;
};


export type MutationSaveElectrificationGoalsArgs = {
  input: Array<ElectrificationGoalInput>;
};


export type MutationSaveEquipmentArgs = {
  input: Array<EquipmentInput>;
};


export type MutationSaveEquipmentClassesArgs = {
  input: Array<EquipmentClassInput>;
};


export type MutationSaveEquipmentMakeArgs = {
  input: EquipmentMakeInput;
};


export type MutationSaveEquipmentMakeSeriesArgs = {
  input: Array<EquipmentMakeSeriesInput>;
};


export type MutationSaveEquipmentMakesArgs = {
  input: Array<EquipmentMakeInput>;
};


export type MutationSaveIncentiveArgs = {
  input: IncentiveInput;
};


export type MutationSaveIncentiveProgramArgs = {
  input: IncentiveProgramInput;
};


export type MutationSaveIncentiveProgramsArgs = {
  input: Array<IncentiveProgramInput>;
};


export type MutationSaveIncentivesArgs = {
  input: Array<IncentiveInput>;
};


export type MutationSaveLeadSourceArgs = {
  input: LeadSourceInput;
};


export type MutationSaveLeadSourcesArgs = {
  input: Array<LeadSourceInput>;
};


export type MutationSaveOneEquipmentArgs = {
  input: EquipmentInput;
};


export type MutationSavePhotosArgs = {
  input: Array<PhotoInput>;
};


export type MutationSaveProductCategoriesArgs = {
  input: Array<ProductCategoryInput>;
};


export type MutationSaveProductCategoryArgs = {
  input: ProductCategoryInput;
};


export type MutationSaveProposalArgs = {
  input: ProposalInput;
};


export type MutationSaveProposalCategoriesArgs = {
  input: Array<ProposalCategoryInput>;
};


export type MutationSaveProposalCategoryArgs = {
  input: ProposalCategoryInput;
};


export type MutationSaveProposalsArgs = {
  input: Array<ProposalInput>;
};


export type MutationSaveReasonsArgs = {
  input: Array<ReasonInput>;
};


export type MutationSaveReferralArgs = {
  input: ReferralInput;
};


export type MutationSaveReferralsArgs = {
  input: Array<ReferralInput>;
};


export type MutationSaveSalesIntakeFormArgs = {
  input: SaveSalesIntakeFormInput;
};


export type MutationSaveUnitOfMeasureArgs = {
  input?: InputMaybe<UnitOfMeasureInput>;
};


export type MutationSaveUnitsOfMeasureArgs = {
  input: Array<UnitOfMeasureInput>;
};


export type MutationSaveValidatedBuildingProfileArgs = {
  input: ValidatedBuildingProfileInput;
};


export type MutationSaveVideosArgs = {
  input: Array<VideoInput>;
};


export type MutationSaveVisitArgs = {
  input?: InputMaybe<VisitInput>;
};


export type MutationSyncVisitToHubspotArgs = {
  visitId: Scalars['ID'];
};

export enum PaymentType {
  DirectToConsumer = 'DIRECT_TO_CONSUMER',
  DirectToHelioHome = 'DIRECT_TO_HELIO_HOME',
  TaxCredit = 'TAX_CREDIT'
}

export type Photo = {
  __typename?: 'Photo';
  cloudinaryUrl: Scalars['String'];
  createdAt: Scalars['Date'];
  photoId: Scalars['ID'];
  updatedAt: Scalars['Date'];
  visit: Visit;
};

export type PhotoInput = {
  cloudinaryUrl: Scalars['String'];
  visitId: Scalars['ID'];
};

export type PlatformBuildingProfileResult = {
  __typename?: 'PlatformBuildingProfileResult';
  buildingType?: Maybe<Scalars['String']>;
  validatedProfileId: Scalars['ID'];
  validationSource?: Maybe<Scalars['String']>;
  validationSourceId?: Maybe<Scalars['ID']>;
};

export type PowerUnit = {
  __typename?: 'PowerUnit';
  btuPerHour?: Maybe<Scalars['Float']>;
  kilowatts?: Maybe<Scalars['Float']>;
  megawatts?: Maybe<Scalars['Float']>;
  watts?: Maybe<Scalars['Float']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  productCategoryId: Scalars['ID'];
  productCategoryType: ProductCategoryType;
  proposalDisplayOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
};

export type ProductCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  productCategoryType?: InputMaybe<ProductCategoryType>;
  proposalDisplayOrder?: InputMaybe<Scalars['Int']>;
};

export enum ProductCategoryType {
  Any = 'ANY',
  BatteryStorage = 'BATTERY_STORAGE',
  Electrical = 'ELECTRICAL',
  Hvac = 'HVAC',
  Insulation = 'INSULATION',
  Solar = 'SOLAR',
  Ventilation = 'VENTILATION',
  WaterHeater = 'WATER_HEATER'
}

export type Propane = {
  __typename?: 'Propane';
  gallons?: Maybe<Scalars['Float']>;
};

export type Proposal = {
  __typename?: 'Proposal';
  designs: Array<Maybe<Design>>;
  proposalId: Scalars['ID'];
  proposalUrl: Scalars['String'];
  selectedDesign?: Maybe<Design>;
  token: Scalars['String'];
  visit: Visit;
};

export type ProposalCategory = {
  __typename?: 'ProposalCategory';
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  proposalCategoryId: Scalars['ID'];
  proposalCategoryType: ProposalCategoryType;
  proposalDisplayOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
};

export type ProposalCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  proposalCategoryId?: InputMaybe<Scalars['ID']>;
  proposalCategoryType?: InputMaybe<ProposalCategoryType>;
  proposalDisplayOrder?: InputMaybe<Scalars['Int']>;
};

export enum ProposalCategoryType {
  Any = 'ANY',
  BatteryStorage = 'BATTERY_STORAGE',
  Electrical = 'ELECTRICAL',
  Hvac = 'HVAC',
  Insulation = 'INSULATION',
  Solar = 'SOLAR',
  Ventilation = 'VENTILATION',
  WaterHeater = 'WATER_HEATER'
}

export type ProposalFilter = {
  proposalId?: InputMaybe<Scalars['ID']>;
  token?: InputMaybe<Scalars['ID']>;
};

export type ProposalInput = {
  proposalId?: InputMaybe<Scalars['ID']>;
  selectedDesignId?: InputMaybe<Scalars['ID']>;
  visitId?: InputMaybe<Scalars['ID']>;
};

export type ProposalsFilter = {
  visitIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Query = {
  __typename?: 'Query';
  address: Address;
  addressId: Scalars['String'];
  addressLine1: Scalars['String'];
  addresses: Array<Address>;
  allEquipment?: Maybe<Array<Maybe<Equipment>>>;
  bundle: Bundle;
  bundleRule?: Maybe<BundleRule>;
  bundleRules?: Maybe<Array<BundleRule>>;
  bundles: Array<Bundle>;
  customer: Customer;
  customerPortal?: Maybe<CustomerPortal>;
  design?: Maybe<Design>;
  electrificationEngagements?: Maybe<ElectrificationEngagements>;
  electrificationGoals?: Maybe<Array<Maybe<ElectrificationGoal>>>;
  equipment?: Maybe<Equipment>;
  equipmentClasses?: Maybe<Array<Maybe<EquipmentClass>>>;
  equipmentMake?: Maybe<EquipmentMake>;
  equipmentMakeSeries?: Maybe<Array<Maybe<EquipmentMakeSeries>>>;
  equipmentMakes?: Maybe<Array<Maybe<EquipmentMake>>>;
  incentive?: Maybe<Incentive>;
  incentiveProgram?: Maybe<IncentiveProgram>;
  incentivePrograms?: Maybe<Array<Maybe<IncentiveProgram>>>;
  incentives?: Maybe<Array<Maybe<Incentive>>>;
  leadSources: Array<Maybe<LeadSource>>;
  photos: Array<Photo>;
  productCategories: Array<ProductCategory>;
  /** Query one proposal by ID or UUID */
  proposal: Proposal;
  proposalCategories: Array<ProposalCategory>;
  proposals: Array<Proposal>;
  reasons?: Maybe<Array<Maybe<Reason>>>;
  referral: Referral;
  referrals?: Maybe<Array<Maybe<Referral>>>;
  suggestDesign: Design;
  unitsOfMeasure?: Maybe<Array<Maybe<UnitOfMeasure>>>;
  validatedBuildingProfile: ValidatedBuildingProfile;
  videos: Array<Video>;
  visit: Visit;
  visits: Array<Maybe<Visit>>;
};


export type QueryAddressArgs = {
  addressId: Scalars['ID'];
};


export type QueryAddressesArgs = {
  filter?: InputMaybe<AddressFilter>;
};


export type QueryAllEquipmentArgs = {
  filter?: InputMaybe<EquipmentFilter>;
};


export type QueryBundleArgs = {
  bundleId: Scalars['ID'];
};


export type QueryBundleRuleArgs = {
  bundleRuleId: Scalars['ID'];
};


export type QueryBundlesArgs = {
  filter?: InputMaybe<BundleFilter>;
};


export type QueryCustomerArgs = {
  customerId: Scalars['ID'];
};


export type QueryCustomerPortalArgs = {
  input: CustomerPortalQueryInput;
};


export type QueryDesignArgs = {
  designId: Scalars['ID'];
};


export type QueryEquipmentArgs = {
  equipmentId: Scalars['ID'];
};


export type QueryEquipmentMakeArgs = {
  equipmentMakeId: Scalars['ID'];
};


export type QueryIncentiveArgs = {
  incentiveId: Scalars['ID'];
};


export type QueryIncentiveProgramArgs = {
  incentiveProgramId: Scalars['ID'];
};


export type QueryProposalArgs = {
  input: ProposalFilter;
};


export type QueryProposalsArgs = {
  filter?: InputMaybe<ProposalsFilter>;
};


export type QueryReferralArgs = {
  referralId: Scalars['ID'];
};


export type QuerySuggestDesignArgs = {
  input: SuggestDesignInput;
};


export type QueryValidatedBuildingProfileArgs = {
  validatedBuildingProfileId: Scalars['ID'];
};


export type QueryVisitArgs = {
  visitId: Scalars['ID'];
};


export type QueryVisitsArgs = {
  filter?: InputMaybe<VisitsFilter>;
};

export type Reason = {
  __typename?: 'Reason';
  reasonId: Scalars['ID'];
  reasonText: Scalars['String'];
};

export type ReasonInput = {
  reasonId?: InputMaybe<Scalars['ID']>;
  reasonText: Scalars['String'];
};

export type Referral = {
  __typename?: 'Referral';
  referralId?: Maybe<Scalars['ID']>;
  referralText?: Maybe<Scalars['String']>;
};

export type ReferralInput = {
  referralId?: InputMaybe<Scalars['ID']>;
  referralText?: InputMaybe<Scalars['String']>;
};

export enum RoofMaterialType {
  AsphaltOrFiberglassShingles = 'ASPHALT_OR_FIBERGLASS_SHINGLES',
  Concrete = 'CONCRETE',
  CoolRoof = 'COOL_ROOF',
  ExpandedPolystyreneSheathing = 'EXPANDED_POLYSTYRENE_SHEATHING',
  MetalSurfacing = 'METAL_SURFACING',
  PlasticOrRubberOrSyntheticSheeting = 'PLASTIC_OR_RUBBER_OR_SYNTHETIC_SHEETING',
  Shingles = 'SHINGLES',
  SlateOrTileShingles = 'SLATE_OR_TILE_SHINGLES',
  WoodShinglesOrShakes = 'WOOD_SHINGLES_OR_SHAKES'
}

export type SaveAddressesResponse = {
  __typename?: 'SaveAddressesResponse';
  addresses: Array<Maybe<Address>>;
};

export type SaveBuildingProfileResult = {
  __typename?: 'SaveBuildingProfileResult';
  validatedBuildingProfile?: Maybe<PlatformBuildingProfileResult>;
  visit?: Maybe<Visit>;
};

export type SaveBundleResult = {
  __typename?: 'SaveBundleResult';
  bundle?: Maybe<Bundle>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SaveBundlesResult = {
  __typename?: 'SaveBundlesResult';
  bundles: Array<Maybe<Bundle>>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SaveCustomerProposalInput = {
  pdfUrl: Scalars['String'];
  retoolDesignJson?: InputMaybe<Scalars['JSON']>;
  solarDesignImageUrl?: InputMaybe<Scalars['String']>;
  visitId: Scalars['ID'];
};

export type SaveCustomersResponse = {
  __typename?: 'SaveCustomersResponse';
  customers?: Maybe<Array<Customer>>;
};

export type SaveElectrificationGoalsResponse = {
  __typename?: 'SaveElectrificationGoalsResponse';
  electrificationGoals: Array<Maybe<ElectrificationGoal>>;
};

export type SaveEquipmentClassResponse = {
  __typename?: 'SaveEquipmentClassResponse';
  equipmentClasses?: Maybe<Array<Maybe<EquipmentClass>>>;
};

export type SaveEquipmentMakeResponse = {
  __typename?: 'SaveEquipmentMakeResponse';
  equipmentMakes?: Maybe<Array<EquipmentMake>>;
};

export type SaveEquipmentResponse = {
  __typename?: 'SaveEquipmentResponse';
  equipment?: Maybe<Array<Equipment>>;
};

export type SaveIncentiveProgramsResponse = {
  __typename?: 'SaveIncentiveProgramsResponse';
  incentivePrograms: Array<Maybe<IncentiveProgram>>;
};

export type SaveIncentiveResponse = {
  __typename?: 'SaveIncentiveResponse';
  incentive?: Maybe<Incentive>;
};

export type SaveIncentivesResponse = {
  __typename?: 'SaveIncentivesResponse';
  incentives: Array<Maybe<Incentive>>;
};

export type SaveLeadSourcesResponse = {
  __typename?: 'SaveLeadSourcesResponse';
  leadSources: Array<Maybe<LeadSource>>;
};

export type SavePhotosResponse = {
  __typename?: 'SavePhotosResponse';
  photos: Array<Photo>;
};

export type SaveProductCategoriesResponse = {
  __typename?: 'SaveProductCategoriesResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCategories: Array<Maybe<ProductCategory>>;
};

export type SaveProductCategoryResponse = {
  __typename?: 'SaveProductCategoryResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCategory?: Maybe<ProductCategory>;
};

export type SaveProposalCategoriesResponse = {
  __typename?: 'SaveProposalCategoriesResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  proposalCategories: Array<Maybe<ProposalCategory>>;
};

export type SaveProposalCategoryResponse = {
  __typename?: 'SaveProposalCategoryResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  proposalCategory?: Maybe<ProposalCategory>;
};

export type SaveReasonsResponse = {
  __typename?: 'SaveReasonsResponse';
  reasons: Array<Maybe<Reason>>;
};

export type SaveReferralsResponse = {
  __typename?: 'SaveReferralsResponse';
  referrals?: Maybe<Array<Referral>>;
};

/**
 * This input supports more fields than the ValidatedBuildingProfileInput
 * and does not require addressId since visitId is required
 */
export type SaveSalesIntakeFormInput = {
  basementSqFt?: InputMaybe<Scalars['Float']>;
  buildingType?: InputMaybe<Scalars['String']>;
  clothesDryerCount?: InputMaybe<Scalars['Int']>;
  clothesDryerFuel?: InputMaybe<Scalars['String']>;
  conditionedFloorAreaSqFt?: InputMaybe<Scalars['Float']>;
  coolingSystems?: InputMaybe<Array<InputMaybe<CoolingSystemInput>>>;
  crawlspaceSqFt?: InputMaybe<Scalars['Float']>;
  floorsAboveGrade?: InputMaybe<Scalars['Float']>;
  garageLocation?: InputMaybe<Scalars['String']>;
  garageSqFt?: InputMaybe<Scalars['Float']>;
  hasAttic?: InputMaybe<Scalars['Boolean']>;
  hasBasement?: InputMaybe<Scalars['Boolean']>;
  hasCrawlspace?: InputMaybe<Scalars['Boolean']>;
  hasEvCharger?: InputMaybe<Scalars['Boolean']>;
  hasGarage?: InputMaybe<Scalars['Boolean']>;
  hasHottub?: InputMaybe<Scalars['Boolean']>;
  hasPool?: InputMaybe<Scalars['Boolean']>;
  hasSolar?: InputMaybe<Scalars['Boolean']>;
  hasStorageBattery?: InputMaybe<Scalars['Boolean']>;
  heatingSystems?: InputMaybe<Array<InputMaybe<HeatingSystemInput>>>;
  homeOwnerAssessedLeakage?: InputMaybe<Scalars['Float']>;
  homeOwnerAssessedTemp?: InputMaybe<Scalars['Float']>;
  isBasementConditioned?: InputMaybe<Scalars['Boolean']>;
  isBasementFinished?: InputMaybe<Scalars['Boolean']>;
  isCrawlspaceConditioned?: InputMaybe<Scalars['Boolean']>;
  isCrawlspaceVented?: InputMaybe<Scalars['Boolean']>;
  occupancy?: InputMaybe<Scalars['Int']>;
  parkingSpaces?: InputMaybe<Scalars['Int']>;
  roofShadinessFactor?: InputMaybe<Scalars['Float']>;
  servicePanelSize?: InputMaybe<Scalars['Int']>;
  spaceAboveGarage?: InputMaybe<Scalars['String']>;
  stoveTopType?: InputMaybe<Scalars['String']>;
  visitId: Scalars['ID'];
  waterHeater?: InputMaybe<WaterHeaterInput>;
  yearBuilt?: InputMaybe<Scalars['Int']>;
  yearBuiltEffective?: InputMaybe<Scalars['Int']>;
};

export type SaveVideosResponse = {
  __typename?: 'SaveVideosResponse';
  videos: Array<Video>;
};

export type SimulationResult = {
  __typename?: 'SimulationResult';
  annualResult?: Maybe<AnnualResult>;
  createdAt: Scalars['String'];
  hpxmlResult?: Maybe<HpxmlResult>;
  inputConfig?: Maybe<Scalars['JSON']>;
  runLogs?: Maybe<Scalars['String']>;
  simulationId: Scalars['ID'];
  simulationType: Scalars['String'];
  status: SimulationState;
  summaryResults?: Maybe<SummaryResults>;
  updatedAt: Scalars['String'];
  validatedProfileId: Scalars['ID'];
};

export enum SimulationState {
  Errored = 'ERRORED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export type SolarPotential = {
  __typename?: 'SolarPotential';
  estimatedSolarProduction: Scalars['Float'];
  firstYearSavings: Scalars['Float'];
  priceInCents: Scalars['Int'];
  systemSize: Scalars['Float'];
  totalSolarPriceInCents: Scalars['Int'];
  yearPayback: Scalars['Float'];
};

export type SuggestDesignInput = {
  designType: DesignType;
  proposalId: Scalars['ID'];
};

export type SummaryResults = {
  __typename?: 'SummaryResults';
  co2ProductionTotal?: Maybe<Scalars['Float']>;
  energyEfficiencyImprovement?: Maybe<Scalars['Float']>;
  energyUseIntensityScore?: Maybe<Scalars['Float']>;
  fuelUseElectricityTotal?: Maybe<HeatUnit>;
  fuelUseNaturalGasTotal?: Maybe<HeatUnit>;
  fuelUsePropaneTotal?: Maybe<Propane>;
  totalEnergyConsumption?: Maybe<HeatUnit>;
};

export type SyncVisitToHubspotResult = {
  __typename?: 'SyncVisitToHubspotResult';
  deal?: Maybe<HubspotDeal>;
  error: Array<Maybe<Scalars['String']>>;
  visit: Visit;
};

export type TimeUnit = {
  __typename?: 'TimeUnit';
  hours?: Maybe<Scalars['Float']>;
};

export enum TypeOfInfiltrationMeasurement {
  BlowerDoor = 'BLOWER_DOOR',
  Estimate = 'ESTIMATE'
}

export type UnitOfMeasure = {
  __typename?: 'UnitOfMeasure';
  abbreviation: Scalars['String'];
  name: Scalars['String'];
  unitOfMeasureId: Scalars['ID'];
};

export type UnitOfMeasureInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  unitOfMeasureId?: InputMaybe<Scalars['ID']>;
};

export type UpgradeEnergyMeasures = {
  __typename?: 'UpgradeEnergyMeasures';
  baseline: EnergyUsage;
  heatPumpHvac: EnergyUsage;
  heatPumpHvacAndInsulation: EnergyUsage;
  heatPumpHvacAndWaterHeater: EnergyUsage;
  heatPumpHvacAndWaterHeaterAndInsulation: EnergyUsage;
  heatPumpWaterHeater: EnergyUsage;
  heatPumpWaterHeaterAndInsulation: EnergyUsage;
  insulation: EnergyUsage;
};

export type ValidatedBuildingProfile = BaseBuildingProfile & {
  __typename?: 'ValidatedBuildingProfile';
  airLeakageCfm?: Maybe<Scalars['Float']>;
  atticAssemblyRValue?: Maybe<Scalars['Float']>;
  averageCeilingHeight?: Maybe<Scalars['Float']>;
  basementDepthBelowGradeFt?: Maybe<Scalars['Float']>;
  basementFoundationWallRValue?: Maybe<Scalars['Float']>;
  basementSlabRValue?: Maybe<Scalars['Float']>;
  basementSqFt?: Maybe<Scalars['Float']>;
  bathroomCount?: Maybe<Scalars['Float']>;
  bedroomCount?: Maybe<Scalars['Int']>;
  buildingProfileId?: Maybe<Scalars['ID']>;
  buildingType?: Maybe<Scalars['String']>;
  clothesDryerCount?: Maybe<Scalars['Int']>;
  clothesDryerFuel?: Maybe<Scalars['String']>;
  conditionedFloorAreaSqFt?: Maybe<Scalars['Float']>;
  coolingSystems?: Maybe<Array<Maybe<CoolingSystem>>>;
  crawlspaceDepthBelowGradeFt?: Maybe<Scalars['Float']>;
  crawlspaceFoundationWallRValue?: Maybe<Scalars['Float']>;
  crawlspaceSqFt?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  exteriorWallAssemblyRValue?: Maybe<Scalars['Float']>;
  floorsAboveGrade?: Maybe<Scalars['Float']>;
  foundationType?: Maybe<Scalars['String']>;
  garageCeilingRValue?: Maybe<Scalars['Float']>;
  garageLocation?: Maybe<Scalars['String']>;
  garageSqFt?: Maybe<Scalars['Float']>;
  hasAttic?: Maybe<Scalars['Boolean']>;
  hasBasement?: Maybe<Scalars['Boolean']>;
  hasCrawlspace?: Maybe<Scalars['Boolean']>;
  hasEvCharger?: Maybe<Scalars['Boolean']>;
  hasGarage?: Maybe<Scalars['Boolean']>;
  hasHottub?: Maybe<Scalars['Boolean']>;
  hasPool?: Maybe<Scalars['Boolean']>;
  hasSlabOnGrade?: Maybe<Scalars['Boolean']>;
  hasSolar?: Maybe<Scalars['Boolean']>;
  hasStorageBattery?: Maybe<Scalars['Boolean']>;
  heatingSystems?: Maybe<Array<Maybe<HeatingSystem>>>;
  homeOwnerAssessedLeakage?: Maybe<Scalars['Float']>;
  homeOwnerAssessedTemp?: Maybe<Scalars['Float']>;
  isBasementConditioned?: Maybe<Scalars['Boolean']>;
  isBasementFinished?: Maybe<Scalars['Boolean']>;
  isCrawlspaceConditioned?: Maybe<Scalars['Boolean']>;
  isCrawlspaceVented?: Maybe<Scalars['Boolean']>;
  isSlabInsulated?: Maybe<Scalars['Boolean']>;
  latestSimulation?: Maybe<SimulationResult>;
  length?: Maybe<Scalars['Float']>;
  occupancy?: Maybe<Scalars['Int']>;
  otherFrameFloorRValue?: Maybe<Scalars['Float']>;
  otherFrameFloorSqFt?: Maybe<Scalars['Int']>;
  parkingSpaces?: Maybe<Scalars['Int']>;
  roofMaterialType?: Maybe<RoofMaterialType>;
  roofShadinessFactor?: Maybe<Scalars['Float']>;
  roofStyle?: Maybe<Scalars['String']>;
  servicePanelSize?: Maybe<Scalars['Int']>;
  sidingType?: Maybe<Scalars['String']>;
  simulations?: Maybe<Array<Maybe<SimulationResult>>>;
  slabOnGradeRValue?: Maybe<Scalars['Float']>;
  slabSqFt?: Maybe<Scalars['Float']>;
  spaceAboveGarage?: Maybe<Scalars['String']>;
  stoveTopType?: Maybe<Scalars['String']>;
  typeOfInfiltrationMeasurement?: Maybe<TypeOfInfiltrationMeasurement>;
  upgradeEnergyMeasures?: Maybe<UpgradeEnergyMeasures>;
  validatedProfileId: Scalars['ID'];
  validationSource?: Maybe<Scalars['String']>;
  validationSourceId?: Maybe<Scalars['ID']>;
  visit?: Maybe<Visit>;
  wallConstructionType?: Maybe<Scalars['String']>;
  waterHeater?: Maybe<WaterHeater>;
  width?: Maybe<Scalars['Float']>;
  windowSurfaceAreaPercentage?: Maybe<Scalars['Float']>;
  windowType?: Maybe<Scalars['String']>;
  windowUFactor?: Maybe<Scalars['Float']>;
  yearBuilt?: Maybe<Scalars['Int']>;
  yearBuiltEffective?: Maybe<Scalars['Int']>;
};

export type ValidatedBuildingProfileInput = {
  addressId: Scalars['ID'];
  airLeakageCfm?: InputMaybe<Scalars['Float']>;
  atticAssemblyRValue?: InputMaybe<Scalars['Float']>;
  averageCeilingHeight?: InputMaybe<Scalars['Float']>;
  basementDepthBelowGradeFt?: InputMaybe<Scalars['Float']>;
  basementFoundationWallRValue?: InputMaybe<Scalars['Float']>;
  basementSlabRValue?: InputMaybe<Scalars['Float']>;
  basementSqFt?: InputMaybe<Scalars['Float']>;
  buildingType?: InputMaybe<Scalars['String']>;
  conditionedFloorAreaSqFt?: InputMaybe<Scalars['Float']>;
  coolingSystems?: InputMaybe<Array<InputMaybe<CoolingSystemInput>>>;
  crawlspaceDepthBelowGradeFt?: InputMaybe<Scalars['Float']>;
  crawlspaceFoundationWallRValue?: InputMaybe<Scalars['Float']>;
  crawlspaceSqFt?: InputMaybe<Scalars['Float']>;
  exteriorWallAssemblyRValue?: InputMaybe<Scalars['Float']>;
  floorsAboveGrade?: InputMaybe<Scalars['Float']>;
  foundationType?: InputMaybe<Scalars['String']>;
  garageCeilingRValue?: InputMaybe<Scalars['Float']>;
  garageLocation?: InputMaybe<Scalars['String']>;
  garageSqFt?: InputMaybe<Scalars['Float']>;
  hasAttic?: InputMaybe<Scalars['Boolean']>;
  hasBasement?: InputMaybe<Scalars['Boolean']>;
  hasCrawlspace?: InputMaybe<Scalars['Boolean']>;
  hasEvCharger?: InputMaybe<Scalars['Boolean']>;
  hasGarage?: InputMaybe<Scalars['Boolean']>;
  hasHottub?: InputMaybe<Scalars['Boolean']>;
  hasPool?: InputMaybe<Scalars['Boolean']>;
  hasSlabOnGrade?: InputMaybe<Scalars['Boolean']>;
  hasSolar?: InputMaybe<Scalars['Boolean']>;
  hasStorageBattery?: InputMaybe<Scalars['Boolean']>;
  heatingSystems?: InputMaybe<Array<InputMaybe<HeatingSystemInput>>>;
  homeOwnerAssessedLeakage?: InputMaybe<Scalars['Float']>;
  homeOwnerAssessedTemp?: InputMaybe<Scalars['Float']>;
  hubspotDealId?: InputMaybe<Scalars['ID']>;
  isBasementConditioned?: InputMaybe<Scalars['Boolean']>;
  isBasementFinished?: InputMaybe<Scalars['Boolean']>;
  isCrawlspaceConditioned?: InputMaybe<Scalars['Boolean']>;
  isCrawlspaceVented?: InputMaybe<Scalars['Boolean']>;
  isSlabInsulated?: InputMaybe<Scalars['Boolean']>;
  length?: InputMaybe<Scalars['Float']>;
  occupancy?: InputMaybe<Scalars['Int']>;
  otherFrameFloorRValue?: InputMaybe<Scalars['Float']>;
  otherFrameFloorSqFt?: InputMaybe<Scalars['Int']>;
  roofMaterialType?: InputMaybe<RoofMaterialType>;
  roofShadinessFactor?: InputMaybe<Scalars['Float']>;
  roofStyle?: InputMaybe<Scalars['String']>;
  servicePanelSize?: InputMaybe<Scalars['Int']>;
  sidingType?: InputMaybe<Scalars['String']>;
  slabOnGradeRValue?: InputMaybe<Scalars['Float']>;
  slabSqFt?: InputMaybe<Scalars['Float']>;
  spaceAboveGarage?: InputMaybe<Scalars['String']>;
  stoveTopType?: InputMaybe<Scalars['String']>;
  typeOfInfiltrationMeasurement?: InputMaybe<TypeOfInfiltrationMeasurement>;
  /**
   * set validationSource to "designer" for changes from the design workbench
   * otherwise leave blank and we will set this to "cx_visit" or "sales_visit"
   */
  validationSource?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['ID']>;
  wallConstructionType?: InputMaybe<Scalars['String']>;
  waterHeater?: InputMaybe<WaterHeaterInput>;
  width?: InputMaybe<Scalars['Float']>;
  windowSurfaceAreaPercentage?: InputMaybe<Scalars['Float']>;
  windowType?: InputMaybe<Scalars['String']>;
  windowUFactor?: InputMaybe<Scalars['Float']>;
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

export type Video = {
  __typename?: 'Video';
  cloudinaryUrl: Scalars['String'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  videoId: Scalars['ID'];
};

export type VideoInput = {
  cloudinaryUrl: Scalars['String'];
  visitId: Scalars['ID'];
};

export type Visit = {
  __typename?: 'Visit';
  address: Address;
  clonedFrom?: Maybe<Visit>;
  createdAt: Scalars['Date'];
  customer?: Maybe<Customer>;
  customerAdditionalInformation?: Maybe<Scalars['String']>;
  designNotes?: Maybe<Scalars['String']>;
  electrificationEngagement?: Maybe<ElectrificationEngagement>;
  electrificationGoals?: Maybe<Array<Maybe<ElectrificationGoal>>>;
  hubspotDealId?: Maybe<Scalars['ID']>;
  hubspotOwnerId?: Maybe<Scalars['ID']>;
  leadSource?: Maybe<LeadSource>;
  photos?: Maybe<Array<Maybe<Photo>>>;
  proposals?: Maybe<Array<Maybe<Proposal>>>;
  reasons?: Maybe<Array<Maybe<Reason>>>;
  referral?: Maybe<Referral>;
  shouldSyncToHubspot?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Date'];
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmId?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
  validatedBuildingProfiles?: Maybe<Array<ValidatedBuildingProfile>>;
  videos?: Maybe<Array<Maybe<Video>>>;
  visitId: Scalars['ID'];
};

export type VisitInput = {
  addressId?: InputMaybe<Scalars['ID']>;
  customerAdditionalInformation?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  designNotes?: InputMaybe<Scalars['String']>;
  electrificationGoalIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  hubspotDealId?: InputMaybe<Scalars['ID']>;
  leadSource?: InputMaybe<Scalars['String']>;
  preferredContactMethod?: InputMaybe<Scalars['String']>;
  reasonIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  referralId?: InputMaybe<Scalars['ID']>;
  /** deprecated use utmCampaign instead */
  sourceCampaign?: InputMaybe<Scalars['String']>;
  /** deprecated use utmTerm instead */
  sourceKeyword?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmId?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
  validatedProfileId?: InputMaybe<Scalars['ID']>;
  visitId?: InputMaybe<Scalars['ID']>;
};

export type VisitsFilter = {
  isTest?: InputMaybe<Scalars['Boolean']>;
  shouldSyncToHubspot?: InputMaybe<Scalars['Boolean']>;
};

export type VolumeUnit = {
  __typename?: 'VolumeUnit';
  gallons?: Maybe<Scalars['Float']>;
};

export type WaterHeater = {
  __typename?: 'WaterHeater';
  fuelType?: Maybe<Scalars['String']>;
  tankVolume?: Maybe<Scalars['Int']>;
  yearInstalled?: Maybe<Scalars['Int']>;
};

export type WaterHeaterInput = {
  fuelType?: InputMaybe<Scalars['String']>;
  tankVolume?: InputMaybe<Scalars['Int']>;
  yearInstalled?: InputMaybe<Scalars['Int']>;
};

export type SaveCustomerMutationVariables = Exact<{
  input: CustomerInput;
}>;


export type SaveCustomerMutation = { __typename?: 'Mutation', saveCustomer: { __typename?: 'Customer', customerId?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, addresses?: Array<{ __typename?: 'Address', addressId: string }> | null } };

export type CustomerPortalQueryVariables = Exact<{
  input: CustomerPortalQueryInput;
}>;


export type CustomerPortalQuery = { __typename?: 'Query', customerPortal?: { __typename?: 'CustomerPortal', proposalId: string, deals?: Array<{ __typename?: 'Deal', hsObjectId?: string | null } | null> | null, visit: { __typename?: 'Visit', visitId: string, customer?: { __typename?: 'Customer', hubspotContactId?: string | null } | null, address: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, postalCode: string } } } | null };

export type SubmitNewAddressMutationVariables = Exact<{
  input: Array<AddressInput> | AddressInput;
}>;


export type SubmitNewAddressMutation = { __typename?: 'Mutation', saveAddresses: { __typename?: 'SaveAddressesResponse', addresses: Array<{ __typename?: 'Address', addressId: string, addressLine1: string, locationDetails?: { __typename?: 'AddressLocationDetails', currentSalesTerritoryContainsLocation: boolean } | null } | null> } };

export type ElectrificationSummaryQueryVariables = Exact<{
  validatedBuildingProfileId: Scalars['ID'];
}>;


export type ElectrificationSummaryQuery = { __typename?: 'Query', validatedBuildingProfile: { __typename?: 'ValidatedBuildingProfile', validatedProfileId: string, stoveTopType?: string | null, conditionedFloorAreaSqFt?: number | null, yearBuilt?: number | null, waterHeater?: { __typename?: 'WaterHeater', yearInstalled?: number | null, fuelType?: string | null } | null, heatingSystems?: Array<{ __typename?: 'HeatingSystem', yearInstalled?: number | null, heatingSystemFuelType: string } | null> | null, coolingSystems?: Array<{ __typename?: 'CoolingSystem', yearInstalled?: number | null } | null> | null, upgradeEnergyMeasures?: { __typename?: 'UpgradeEnergyMeasures', baseline: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpHvac: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpWaterHeater: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), insulation: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpHvacAndWaterHeater: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpHvacAndWaterHeaterAndInsulation: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpHvacAndInsulation: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpWaterHeaterAndInsulation: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ) } | null } };

export type EnergyUsageStatsFragment = { __typename?: 'EnergyUsage', energyUseIntensityScore?: number | null, co2Tons?: number | null, energyEfficiencyImprovement?: number | null, electrifiedEnergyUsageKwh?: number | null, solarPotential?: { __typename?: 'SolarPotential', estimatedSolarProduction: number, systemSize: number, firstYearSavings: number, yearPayback: number, priceInCents: number, totalSolarPriceInCents: number } | null } & { ' $fragmentName'?: 'EnergyUsageStatsFragment' };

export type SaveElectrificationEngagementMutationVariables = Exact<{
  input: ElectrificationEngagementInput;
}>;


export type SaveElectrificationEngagementMutation = { __typename?: 'Mutation', saveElectrificationEngagement: { __typename?: 'ElectrificationEngagement', electrificationEngagementId: string, heatPumpHvac?: boolean | null, heatPumpWaterHeater?: boolean | null, insulation?: boolean | null, solar?: boolean | null, storageBattery?: boolean | null, vehicleCharger?: boolean | null, homeVentilation?: boolean | null, inductionStove?: boolean | null, electricalServiceUpgrade?: boolean | null } };

export type CustomerInterestsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerInterestsQuery = { __typename?: 'Query', electrificationGoals?: Array<{ __typename?: 'ElectrificationGoal', electrificationGoalId: string, electrificationGoalText: string } | null> | null, referrals?: Array<{ __typename?: 'Referral', referralId?: string | null, referralText?: string | null } | null> | null, reasons?: Array<{ __typename?: 'Reason', reasonId: string, reasonText: string } | null> | null };

export type SaveVisitMutationVariables = Exact<{
  input: VisitInput;
}>;


export type SaveVisitMutation = { __typename?: 'Mutation', saveVisit: { __typename?: 'Visit', visitId: string, electrificationEngagement?: { __typename?: 'ElectrificationEngagement', electrificationEngagementId: string } | null } };

export type HomeSummaryQueryVariables = Exact<{
  validatedBuildingProfileId: Scalars['ID'];
}>;


export type HomeSummaryQuery = { __typename?: 'Query', validatedBuildingProfile: { __typename?: 'ValidatedBuildingProfile', validatedProfileId: string, homeOwnerAssessedLeakage?: number | null, homeOwnerAssessedTemp?: number | null, bedroomCount?: number | null, bathroomCount?: number | null, conditionedFloorAreaSqFt?: number | null, floorsAboveGrade?: number | null, buildingType?: string | null, yearBuilt?: number | null, hasAttic?: boolean | null, hasBasement?: boolean | null, hasSolar?: boolean | null, hasStorageBattery?: boolean | null, hasEvCharger?: boolean | null, isBasementFinished?: boolean | null, stoveTopType?: string | null, servicePanelSize?: number | null, waterHeater?: { __typename?: 'WaterHeater', yearInstalled?: number | null, fuelType?: string | null } | null, heatingSystems?: Array<{ __typename?: 'HeatingSystem', yearInstalled?: number | null, heatingSystemFuelType: string } | null> | null, coolingSystems?: Array<{ __typename?: 'CoolingSystem', yearInstalled?: number | null } | null> | null, upgradeEnergyMeasures?: { __typename?: 'UpgradeEnergyMeasures', baseline: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpHvac: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpWaterHeater: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), insulation: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpHvacAndWaterHeater: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpHvacAndWaterHeaterAndInsulation: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpHvacAndInsulation: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ), heatPumpWaterHeaterAndInsulation: (
        { __typename?: 'EnergyUsage' }
        & { ' $fragmentRefs'?: { 'EnergyUsageStatsFragment': EnergyUsageStatsFragment } }
      ) } | null } };

export type NextStepsQueryVariables = Exact<{
  visitId: Scalars['ID'];
}>;


export type NextStepsQuery = { __typename?: 'Query', visit: { __typename?: 'Visit', visitId: string, hubspotOwnerId?: string | null, customer?: { __typename?: 'Customer', customerId?: string | null, firstName?: string | null, lastName?: string | null } | null, photos?: Array<{ __typename?: 'Photo', photoId: string, cloudinaryUrl: string } | null> | null, videos?: Array<{ __typename?: 'Video', videoId: string, cloudinaryUrl: string } | null> | null } };

export type SavePhotosMutationVariables = Exact<{
  input: Array<PhotoInput> | PhotoInput;
}>;


export type SavePhotosMutation = { __typename?: 'Mutation', savePhotos: { __typename?: 'SavePhotosResponse', photos: Array<{ __typename?: 'Photo', photoId: string, cloudinaryUrl: string }> } };

export type SaveVideosMutationVariables = Exact<{
  input: Array<VideoInput> | VideoInput;
}>;


export type SaveVideosMutation = { __typename?: 'Mutation', saveVideos: { __typename?: 'SaveVideosResponse', videos: Array<{ __typename?: 'Video', videoId: string, cloudinaryUrl: string }> } };

export type PropertyProfileFormQueryVariables = Exact<{
  addressId: Scalars['ID'];
}>;


export type PropertyProfileFormQuery = { __typename?: 'Query', address: { __typename?: 'Address', addressId: string, buildingProfile?: (
      { __typename?: 'BuildingProfile', buildingProfileId?: string | null }
      & { ' $fragmentRefs'?: { 'BuildingProfileForm_BuildingProfile_Fragment': BuildingProfileForm_BuildingProfile_Fragment } }
    ) | null } };

export type SalesPropertyProfileQueryVariables = Exact<{
  validatedBuildingProfileId: Scalars['ID'];
}>;


export type SalesPropertyProfileQuery = { __typename?: 'Query', validatedBuildingProfile: (
    { __typename?: 'ValidatedBuildingProfile', validatedProfileId: string, hasBasement?: boolean | null, servicePanelSize?: number | null, visit?: { __typename?: 'Visit', visitId: string, customerAdditionalInformation?: string | null, address: { __typename?: 'Address', addressId: string, addressLine1: string, city: string, state: string, postalCode: string, county: string, createdAt: any, updatedAt: any, isTest: boolean }, customer?: { __typename?: 'Customer', customerId?: string | null, firstName?: string | null, lastName?: string | null, createdAt: any, updatedAt: any, isTest: boolean } | null, leadSource?: { __typename?: 'LeadSource', leadSourceId: string, leadSourceText?: string | null } | null, electrificationGoals?: Array<{ __typename?: 'ElectrificationGoal', electrificationGoalId: string, electrificationGoalText: string } | null> | null, reasons?: Array<{ __typename?: 'Reason', reasonId: string, reasonText: string } | null> | null, referral?: { __typename?: 'Referral', referralId?: string | null, referralText?: string | null } | null } | null }
    & { ' $fragmentRefs'?: { 'BuildingProfileForm_ValidatedBuildingProfile_Fragment': BuildingProfileForm_ValidatedBuildingProfile_Fragment } }
  ) };

type BuildingProfileForm_BuildingProfile_Fragment = { __typename?: 'BuildingProfile', buildingProfileId?: string | null, bathroomCount?: number | null, buildingType?: string | null, bedroomCount?: number | null, conditionedFloorAreaSqFt?: number | null, floorsAboveGrade?: number | null, hasAttic?: boolean | null, hasBasement?: boolean | null, hasCrawlspace?: boolean | null, hasEvCharger?: boolean | null, hasHottub?: boolean | null, hasPool?: boolean | null, hasSolar?: boolean | null, hasStorageBattery?: boolean | null, homeOwnerAssessedLeakage?: number | null, homeOwnerAssessedTemp?: number | null, isBasementFinished?: boolean | null, servicePanelSize?: number | null, stoveTopType?: string | null, yearBuilt?: number | null, yearBuiltEffective?: number | null, coolingSystems?: Array<{ __typename?: 'CoolingSystem', coolingSystemType: string, yearInstalled?: number | null } | null> | null, heatingSystems?: Array<{ __typename?: 'HeatingSystem', heatingSystemType: string, heatingSystemFuelType: string, yearInstalled?: number | null } | null> | null, waterHeater?: { __typename?: 'WaterHeater', fuelType?: string | null, yearInstalled?: number | null } | null } & { ' $fragmentName'?: 'BuildingProfileForm_BuildingProfile_Fragment' };

type BuildingProfileForm_ValidatedBuildingProfile_Fragment = { __typename?: 'ValidatedBuildingProfile', buildingProfileId?: string | null, bathroomCount?: number | null, buildingType?: string | null, bedroomCount?: number | null, conditionedFloorAreaSqFt?: number | null, floorsAboveGrade?: number | null, hasAttic?: boolean | null, hasBasement?: boolean | null, hasCrawlspace?: boolean | null, hasEvCharger?: boolean | null, hasHottub?: boolean | null, hasPool?: boolean | null, hasSolar?: boolean | null, hasStorageBattery?: boolean | null, homeOwnerAssessedLeakage?: number | null, homeOwnerAssessedTemp?: number | null, isBasementFinished?: boolean | null, servicePanelSize?: number | null, stoveTopType?: string | null, yearBuilt?: number | null, yearBuiltEffective?: number | null, coolingSystems?: Array<{ __typename?: 'CoolingSystem', coolingSystemType: string, yearInstalled?: number | null } | null> | null, heatingSystems?: Array<{ __typename?: 'HeatingSystem', heatingSystemType: string, heatingSystemFuelType: string, yearInstalled?: number | null } | null> | null, waterHeater?: { __typename?: 'WaterHeater', fuelType?: string | null, yearInstalled?: number | null } | null } & { ' $fragmentName'?: 'BuildingProfileForm_ValidatedBuildingProfile_Fragment' };

export type BuildingProfileFormFragment = BuildingProfileForm_BuildingProfile_Fragment | BuildingProfileForm_ValidatedBuildingProfile_Fragment;

export type SaveValidatedBuildingProfileMutationVariables = Exact<{
  input: ValidatedBuildingProfileInput;
}>;


export type SaveValidatedBuildingProfileMutation = { __typename?: 'Mutation', saveValidatedBuildingProfile: { __typename?: 'SaveBuildingProfileResult', validatedBuildingProfile?: { __typename?: 'PlatformBuildingProfileResult', validatedProfileId: string, buildingType?: string | null } | null, visit?: { __typename?: 'Visit', visitId: string } | null } };

export type SalesIntakeFormQueryVariables = Exact<{
  validatedBuildingProfileId: Scalars['ID'];
}>;


export type SalesIntakeFormQuery = { __typename?: 'Query', validatedBuildingProfile: { __typename?: 'ValidatedBuildingProfile', validatedProfileId: string, conditionedFloorAreaSqFt?: number | null, occupancy?: number | null, yearBuilt?: number | null, bedroomCount?: number | null, bathroomCount?: number | null, buildingType?: string | null, floorsAboveGrade?: number | null, stoveTopType?: string | null, homeOwnerAssessedLeakage?: number | null, homeOwnerAssessedTemp?: number | null, hasAttic?: boolean | null, hasEvCharger?: boolean | null, hasSolar?: boolean | null, hasStorageBattery?: boolean | null, hasHottub?: boolean | null, hasPool?: boolean | null, hasCrawlspace?: boolean | null, isCrawlspaceConditioned?: boolean | null, crawlspaceSqFt?: number | null, isCrawlspaceVented?: boolean | null, hasBasement?: boolean | null, basementSqFt?: number | null, isBasementFinished?: boolean | null, isBasementConditioned?: boolean | null, hasGarage?: boolean | null, garageLocation?: string | null, garageSqFt?: number | null, parkingSpaces?: number | null, spaceAboveGarage?: string | null, yearBuiltEffective?: number | null, visit?: { __typename?: 'Visit', visitId: string, designNotes?: string | null, address: { __typename?: 'Address', addressId: string, addressLine1: string, city: string, state: string, postalCode: string }, customer?: { __typename?: 'Customer', customerId?: string | null, firstName?: string | null, lastName?: string | null } | null, clonedFrom?: { __typename?: 'Visit', visitId: string, photos?: Array<{ __typename?: 'Photo', photoId: string, cloudinaryUrl: string } | null> | null } | null, electrificationEngagement?: { __typename?: 'ElectrificationEngagement', electrificationEngagementId: string, heatPumpHvac?: boolean | null, heatPumpWaterHeater?: boolean | null, insulation?: boolean | null, solar?: boolean | null, storageBattery?: boolean | null, vehicleCharger?: boolean | null, homeVentilation?: boolean | null, inductionStove?: boolean | null, electricalServiceUpgrade?: boolean | null } | null } | null, waterHeater?: { __typename?: 'WaterHeater', yearInstalled?: number | null, fuelType?: string | null, tankVolume?: number | null } | null } };

export type SaveSalesIntakeFormMutationVariables = Exact<{
  input: SaveSalesIntakeFormInput;
  visitInput: VisitInput;
}>;


export type SaveSalesIntakeFormMutation = { __typename?: 'Mutation', saveSalesIntakeForm: { __typename?: 'SaveBuildingProfileResult', validatedBuildingProfile?: { __typename?: 'PlatformBuildingProfileResult', validatedProfileId: string, validationSourceId?: string | null, validationSource?: string | null } | null }, saveVisit: { __typename?: 'Visit', visitId: string } };

export type ProposalQueryVariables = Exact<{
  input: ProposalFilter;
}>;


export type ProposalQuery = { __typename?: 'Query', proposal: { __typename?: 'Proposal', proposalId: string, proposalUrl: string, token: string, selectedDesign?: { __typename?: 'Design', designId: string, pdfUrl?: string | null, retoolDesignJson?: any | null, retoolDesignEnergyMeasures?: any | null, solarDesignImageUrl?: string | null } | null, visit: { __typename?: 'Visit', visitId: string, hubspotOwnerId?: string | null, address: { __typename?: 'Address', addressId: string, isTest: boolean, addressLine1: string, addressLine2?: string | null, city: string, state: string, postalCode: string } } } };

export type GetAddressIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddressIdQuery = { __typename?: 'Query', addressId: string };

export type GetAddressLine1QueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddressLine1Query = { __typename?: 'Query', addressLine1: string };

export const EnergyUsageStatsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnergyUsageStats"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnergyUsage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energyUseIntensityScore"}},{"kind":"Field","name":{"kind":"Name","value":"co2Tons"}},{"kind":"Field","name":{"kind":"Name","value":"energyEfficiencyImprovement"}},{"kind":"Field","name":{"kind":"Name","value":"electrifiedEnergyUsageKwh"}},{"kind":"Field","name":{"kind":"Name","value":"solarPotential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedSolarProduction"}},{"kind":"Field","name":{"kind":"Name","value":"systemSize"}},{"kind":"Field","name":{"kind":"Name","value":"firstYearSavings"}},{"kind":"Field","name":{"kind":"Name","value":"yearPayback"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalSolarPriceInCents"}}]}}]}}]} as unknown as DocumentNode<EnergyUsageStatsFragment, unknown>;
export const BuildingProfileFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuildingProfileForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseBuildingProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomCount"}},{"kind":"Field","name":{"kind":"Name","value":"buildingType"}},{"kind":"Field","name":{"kind":"Name","value":"bedroomCount"}},{"kind":"Field","name":{"kind":"Name","value":"conditionedFloorAreaSqFt"}},{"kind":"Field","name":{"kind":"Name","value":"coolingSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coolingSystemType"}},{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"floorsAboveGrade"}},{"kind":"Field","name":{"kind":"Name","value":"hasAttic"}},{"kind":"Field","name":{"kind":"Name","value":"hasBasement"}},{"kind":"Field","name":{"kind":"Name","value":"hasCrawlspace"}},{"kind":"Field","name":{"kind":"Name","value":"hasEvCharger"}},{"kind":"Field","name":{"kind":"Name","value":"hasHottub"}},{"kind":"Field","name":{"kind":"Name","value":"hasPool"}},{"kind":"Field","name":{"kind":"Name","value":"hasSolar"}},{"kind":"Field","name":{"kind":"Name","value":"hasStorageBattery"}},{"kind":"Field","name":{"kind":"Name","value":"heatingSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatingSystemType"}},{"kind":"Field","name":{"kind":"Name","value":"heatingSystemFuelType"}},{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeOwnerAssessedLeakage"}},{"kind":"Field","name":{"kind":"Name","value":"homeOwnerAssessedTemp"}},{"kind":"Field","name":{"kind":"Name","value":"isBasementFinished"}},{"kind":"Field","name":{"kind":"Name","value":"servicePanelSize"}},{"kind":"Field","name":{"kind":"Name","value":"stoveTopType"}},{"kind":"Field","name":{"kind":"Name","value":"waterHeater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fuelType"}},{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearBuilt"}},{"kind":"Field","name":{"kind":"Name","value":"yearBuiltEffective"}}]}}]} as unknown as DocumentNode<BuildingProfileFormFragment, unknown>;
export const SaveCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<SaveCustomerMutation, SaveCustomerMutationVariables>;
export const CustomerPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customerPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerPortalQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerPortal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proposalId"}},{"kind":"Field","name":{"kind":"Name","value":"deals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hsObjectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hubspotContactId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomerPortalQuery, CustomerPortalQueryVariables>;
export const SubmitNewAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitNewAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveAddresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"locationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentSalesTerritoryContainsLocation"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmitNewAddressMutation, SubmitNewAddressMutationVariables>;
export const ElectrificationSummaryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"electrificationSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatedBuildingProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedBuildingProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validatedBuildingProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatedBuildingProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"stoveTopType"}},{"kind":"Field","name":{"kind":"Name","value":"conditionedFloorAreaSqFt"}},{"kind":"Field","name":{"kind":"Name","value":"waterHeater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}},{"kind":"Field","name":{"kind":"Name","value":"fuelType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatingSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}},{"kind":"Field","name":{"kind":"Name","value":"heatingSystemFuelType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coolingSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"upgradeEnergyMeasures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvac"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpWaterHeater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insulation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvacAndWaterHeater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvacAndWaterHeaterAndInsulation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvacAndInsulation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpWaterHeaterAndInsulation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearBuilt"}}]}}]}},...EnergyUsageStatsFragmentDoc.definitions]} as unknown as DocumentNode<ElectrificationSummaryQuery, ElectrificationSummaryQueryVariables>;
export const SaveElectrificationEngagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveElectrificationEngagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ElectrificationEngagementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveElectrificationEngagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"electrificationEngagementId"}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvac"}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpWaterHeater"}},{"kind":"Field","name":{"kind":"Name","value":"insulation"}},{"kind":"Field","name":{"kind":"Name","value":"solar"}},{"kind":"Field","name":{"kind":"Name","value":"storageBattery"}},{"kind":"Field","name":{"kind":"Name","value":"vehicleCharger"}},{"kind":"Field","name":{"kind":"Name","value":"homeVentilation"}},{"kind":"Field","name":{"kind":"Name","value":"inductionStove"}},{"kind":"Field","name":{"kind":"Name","value":"electricalServiceUpgrade"}}]}}]}}]} as unknown as DocumentNode<SaveElectrificationEngagementMutation, SaveElectrificationEngagementMutationVariables>;
export const CustomerInterestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerInterests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"electrificationGoals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"electrificationGoalId"}},{"kind":"Field","name":{"kind":"Name","value":"electrificationGoalText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referrals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralId"}},{"kind":"Field","name":{"kind":"Name","value":"referralText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reasonId"}},{"kind":"Field","name":{"kind":"Name","value":"reasonText"}}]}}]}}]} as unknown as DocumentNode<CustomerInterestsQuery, CustomerInterestsQueryVariables>;
export const SaveVisitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveVisit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveVisit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"electrificationEngagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"electrificationEngagementId"}}]}}]}}]}}]} as unknown as DocumentNode<SaveVisitMutation, SaveVisitMutationVariables>;
export const HomeSummaryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"homeSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatedBuildingProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedBuildingProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validatedBuildingProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatedBuildingProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"homeOwnerAssessedLeakage"}},{"kind":"Field","name":{"kind":"Name","value":"homeOwnerAssessedTemp"}},{"kind":"Field","name":{"kind":"Name","value":"bedroomCount"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomCount"}},{"kind":"Field","name":{"kind":"Name","value":"conditionedFloorAreaSqFt"}},{"kind":"Field","name":{"kind":"Name","value":"floorsAboveGrade"}},{"kind":"Field","name":{"kind":"Name","value":"buildingType"}},{"kind":"Field","name":{"kind":"Name","value":"yearBuilt"}},{"kind":"Field","name":{"kind":"Name","value":"hasAttic"}},{"kind":"Field","name":{"kind":"Name","value":"hasBasement"}},{"kind":"Field","name":{"kind":"Name","value":"hasSolar"}},{"kind":"Field","name":{"kind":"Name","value":"hasStorageBattery"}},{"kind":"Field","name":{"kind":"Name","value":"hasEvCharger"}},{"kind":"Field","name":{"kind":"Name","value":"isBasementFinished"}},{"kind":"Field","name":{"kind":"Name","value":"stoveTopType"}},{"kind":"Field","name":{"kind":"Name","value":"servicePanelSize"}},{"kind":"Field","name":{"kind":"Name","value":"waterHeater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}},{"kind":"Field","name":{"kind":"Name","value":"fuelType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatingSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}},{"kind":"Field","name":{"kind":"Name","value":"heatingSystemFuelType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coolingSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"upgradeEnergyMeasures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvac"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpWaterHeater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insulation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvacAndWaterHeater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvacAndWaterHeaterAndInsulation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvacAndInsulation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpWaterHeaterAndInsulation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnergyUsageStats"}}]}}]}}]}}]}},...EnergyUsageStatsFragmentDoc.definitions]} as unknown as DocumentNode<HomeSummaryQuery, HomeSummaryQueryVariables>;
export const NextStepsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NextSteps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"hubspotOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudinaryUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudinaryUrl"}}]}}]}}]}}]} as unknown as DocumentNode<NextStepsQuery, NextStepsQueryVariables>;
export const SavePhotosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"savePhotos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savePhotos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudinaryUrl"}}]}}]}}]}}]} as unknown as DocumentNode<SavePhotosMutation, SavePhotosMutationVariables>;
export const SaveVideosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveVideos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VideoInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveVideos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudinaryUrl"}}]}}]}}]}}]} as unknown as DocumentNode<SaveVideosMutation, SaveVideosMutationVariables>;
export const PropertyProfileFormDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PropertyProfileForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"buildingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingProfileId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildingProfileForm"}}]}}]}}]}},...BuildingProfileFormFragmentDoc.definitions]} as unknown as DocumentNode<PropertyProfileFormQuery, PropertyProfileFormQueryVariables>;
export const SalesPropertyProfileDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SalesPropertyProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatedBuildingProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedBuildingProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validatedBuildingProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatedBuildingProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"hasBasement"}},{"kind":"Field","name":{"kind":"Name","value":"servicePanelSize"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildingProfileForm"}},{"kind":"Field","name":{"kind":"Name","value":"visit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"customerAdditionalInformation"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isTest"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isTest"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadSourceId"}},{"kind":"Field","name":{"kind":"Name","value":"leadSourceText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"electrificationGoals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"electrificationGoalId"}},{"kind":"Field","name":{"kind":"Name","value":"electrificationGoalText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reasonId"}},{"kind":"Field","name":{"kind":"Name","value":"reasonText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referral"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralId"}},{"kind":"Field","name":{"kind":"Name","value":"referralText"}}]}}]}}]}}]}},...BuildingProfileFormFragmentDoc.definitions]} as unknown as DocumentNode<SalesPropertyProfileQuery, SalesPropertyProfileQueryVariables>;
export const SaveValidatedBuildingProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveValidatedBuildingProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidatedBuildingProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveValidatedBuildingProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedBuildingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"buildingType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}}]}}]}}]}}]} as unknown as DocumentNode<SaveValidatedBuildingProfileMutation, SaveValidatedBuildingProfileMutationVariables>;
export const SalesIntakeFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SalesIntakeForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatedBuildingProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedBuildingProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validatedBuildingProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatedBuildingProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"conditionedFloorAreaSqFt"}},{"kind":"Field","name":{"kind":"Name","value":"occupancy"}},{"kind":"Field","name":{"kind":"Name","value":"yearBuilt"}},{"kind":"Field","name":{"kind":"Name","value":"visit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"designNotes"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clonedFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoId"}},{"kind":"Field","name":{"kind":"Name","value":"cloudinaryUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"electrificationEngagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"electrificationEngagementId"}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpHvac"}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpWaterHeater"}},{"kind":"Field","name":{"kind":"Name","value":"insulation"}},{"kind":"Field","name":{"kind":"Name","value":"solar"}},{"kind":"Field","name":{"kind":"Name","value":"storageBattery"}},{"kind":"Field","name":{"kind":"Name","value":"vehicleCharger"}},{"kind":"Field","name":{"kind":"Name","value":"homeVentilation"}},{"kind":"Field","name":{"kind":"Name","value":"inductionStove"}},{"kind":"Field","name":{"kind":"Name","value":"electricalServiceUpgrade"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bedroomCount"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomCount"}},{"kind":"Field","name":{"kind":"Name","value":"buildingType"}},{"kind":"Field","name":{"kind":"Name","value":"floorsAboveGrade"}},{"kind":"Field","name":{"kind":"Name","value":"stoveTopType"}},{"kind":"Field","name":{"kind":"Name","value":"homeOwnerAssessedLeakage"}},{"kind":"Field","name":{"kind":"Name","value":"homeOwnerAssessedTemp"}},{"kind":"Field","name":{"kind":"Name","value":"hasAttic"}},{"kind":"Field","name":{"kind":"Name","value":"hasEvCharger"}},{"kind":"Field","name":{"kind":"Name","value":"hasSolar"}},{"kind":"Field","name":{"kind":"Name","value":"hasStorageBattery"}},{"kind":"Field","name":{"kind":"Name","value":"hasHottub"}},{"kind":"Field","name":{"kind":"Name","value":"hasPool"}},{"kind":"Field","name":{"kind":"Name","value":"hasCrawlspace"}},{"kind":"Field","name":{"kind":"Name","value":"isCrawlspaceConditioned"}},{"kind":"Field","name":{"kind":"Name","value":"crawlspaceSqFt"}},{"kind":"Field","name":{"kind":"Name","value":"isCrawlspaceVented"}},{"kind":"Field","name":{"kind":"Name","value":"hasBasement"}},{"kind":"Field","name":{"kind":"Name","value":"basementSqFt"}},{"kind":"Field","name":{"kind":"Name","value":"isBasementFinished"}},{"kind":"Field","name":{"kind":"Name","value":"isBasementConditioned"}},{"kind":"Field","name":{"kind":"Name","value":"hasGarage"}},{"kind":"Field","name":{"kind":"Name","value":"garageLocation"}},{"kind":"Field","name":{"kind":"Name","value":"garageSqFt"}},{"kind":"Field","name":{"kind":"Name","value":"parkingSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"spaceAboveGarage"}},{"kind":"Field","name":{"kind":"Name","value":"yearBuiltEffective"}},{"kind":"Field","name":{"kind":"Name","value":"waterHeater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearInstalled"}},{"kind":"Field","name":{"kind":"Name","value":"fuelType"}},{"kind":"Field","name":{"kind":"Name","value":"tankVolume"}}]}}]}}]}}]} as unknown as DocumentNode<SalesIntakeFormQuery, SalesIntakeFormQueryVariables>;
export const SaveSalesIntakeFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveSalesIntakeForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveSalesIntakeFormInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveSalesIntakeForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedBuildingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"validationSourceId"}},{"kind":"Field","name":{"kind":"Name","value":"validationSource"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"saveVisit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}}]}}]}}]} as unknown as DocumentNode<SaveSalesIntakeFormMutation, SaveSalesIntakeFormMutationVariables>;
export const ProposalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Proposal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProposalFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proposalId"}},{"kind":"Field","name":{"kind":"Name","value":"proposalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"selectedDesign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designId"}},{"kind":"Field","name":{"kind":"Name","value":"pdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"retoolDesignJson"}},{"kind":"Field","name":{"kind":"Name","value":"retoolDesignEnergyMeasures"}},{"kind":"Field","name":{"kind":"Name","value":"solarDesignImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"hubspotOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"isTest"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProposalQuery, ProposalQueryVariables>;
export const GetAddressIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAddressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode<GetAddressIdQuery, GetAddressIdQueryVariables>;
export const GetAddressLine1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAddressLine1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode<GetAddressLine1Query, GetAddressLine1QueryVariables>;